@if (length === '0_50') {
<ng-template [ngTemplateOutlet]="numberLine_0_50"></ng-template>
} @if (length === '0_100') {
<ng-template [ngTemplateOutlet]="numberLine_0_100"></ng-template>
} @if (length === '0_500') {
<ng-template [ngTemplateOutlet]="numberLine_0_500"></ng-template>
} @if (length === '0_1000') {
<ng-template [ngTemplateOutlet]="numberLine_0_1000"></ng-template>
} @if (length === '500_1000') {
<ng-template [ngTemplateOutlet]="numberLine_500_1000"></ng-template>
} @if (length === '0_10.000') {
<ng-template [ngTemplateOutlet]="numberLine_0_10000"></ng-template>
} @if (length === '0_100.000') {
<ng-template [ngTemplateOutlet]="numberLine_0_100000"></ng-template>
}

<!-- 0-50 -->
<ng-template #numberLine_0_50>
    <svg
        version="1.1"
        id="numberLine_0_500"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 461.497 26.059"
        style="enable-background: new 0 0 461.497 26.059"
        xml:space="preserve"
    >
        <g id="line">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M7.75,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M0,7.087h461.497"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M453.85,0v14.173"
            />
        </g>
        @if (showMarkers) {
        <g id="markers">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M96.97,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M186.19,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M275.41,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M364.63,0v14.173"
            />
        </g>
        } @if (showNumbers) {
        <g id="numbers">
            <g style="enable-background: new">
                <path
                    d="M5.693,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    C6.194,24.146,5.693,22.786,5.693,21.052z M9.203,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                    c0,1.429,0.323,2.542,1.453,2.542S9.203,22.481,9.203,21.052z"
                ></path>
            </g>
            <g
                style="enable-background: new"
                transform="matrix(1, 0, 0, 1, 3, 0)"
            >
                <path
                    d="M90.438,23.517h1.334v-4.385c0-0.17,0.008-0.332,0.008-0.332h-0.017c0,0-0.059,0.128-0.297,0.357l-0.637,0.637
                    l-0.374-0.382l1.351-1.343h0.561v5.447h1.309v0.527h-3.238V23.517z"
                ></path>
                <path
                    d="M94.314,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    C94.815,24.146,94.314,22.786,94.314,21.052z M97.824,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                    c0,1.429,0.323,2.542,1.453,2.542S97.824,22.481,97.824,21.052z"
                ></path>
            </g>
            <g
                style="enable-background: new"
                transform="matrix(1, 0, 0, 1, 3, 0)"
            >
                <path
                    d="M182.216,19.65c0-0.637-0.467-1.121-1.224-1.121c-0.595,0-1.062,0.306-1.062,0.646v0.28h-0.561v-0.441
                    c0-0.757,1.028-1.046,1.641-1.046c1.139,0,1.818,0.748,1.818,1.675c0,2.099-3.162,2.048-3.162,3.705c0,0.119,0.068,0.17,0.196,0.17
                    h2.499c0.119,0,0.187-0.06,0.187-0.187v-0.399h0.552v0.595c0,0.365-0.153,0.519-0.518,0.519h-2.992
                    c-0.408,0-0.536-0.17-0.536-0.587C179.054,21.24,182.216,21.418,182.216,19.65z"
                ></path>
                <path
                    d="M183.95,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    C184.452,24.146,183.95,22.786,183.95,21.052z M187.46,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                    c0,1.429,0.323,2.542,1.453,2.542S187.46,22.481,187.46,21.052z"
                ></path>
            </g>
            <g
                style="enable-background: new"
                transform="matrix(1, 0, 0, 1, 3, 0)"
            >
                <path
                    d="M268.627,22.871c0,0,0.611,0.714,1.563,0.714c0.705,0,1.352-0.527,1.352-1.292c0-0.808-0.697-1.258-1.454-1.258h-0.416
                    l-0.136-0.349l1.47-1.768c0.145-0.195,0.307-0.331,0.307-0.331v-0.018c0,0-0.17,0.025-0.484,0.025h-1.556
                    c-0.119,0-0.187,0.06-0.187,0.188v0.399h-0.553v-0.595c0-0.366,0.136-0.519,0.501-0.519h3.034v0.391l-1.759,2.065
                    c0.748,0.042,1.844,0.476,1.844,1.759c0,1.012-0.841,1.861-1.972,1.861c-1.182,0-1.912-0.832-1.912-0.832L268.627,22.871z"
                ></path>
                <path
                    d="M273.039,21.052c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    S273.039,22.786,273.039,21.052z M276.548,21.052c0-1.419-0.323-2.532-1.453-2.532c-1.131,0-1.453,1.113-1.453,2.532
                    c0,1.429,0.322,2.542,1.453,2.542C276.225,23.594,276.548,22.481,276.548,21.052z"
                ></path>
            </g>
            <g
                style="enable-background: new"
                transform="matrix(1, 0, 0, 1, 3, 0)"
            >
                <path
                    d="M357.252,22.004l2.906-3.935h0.638v3.799h0.952v0.527h-0.952v1.648h-0.595v-1.648h-2.949V22.004z M360.209,19.429
                    c0-0.255,0.026-0.578,0.026-0.578h-0.018c0,0-0.145,0.247-0.306,0.459l-1.657,2.193c-0.162,0.212-0.314,0.374-0.314,0.374v0.017
                    c0,0,0.237-0.025,0.493-0.025h1.775V19.429z"
                ></path>
                <path
                    d="M362.403,21.052c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    C362.905,24.146,362.403,22.786,362.403,21.052z M365.914,21.052c0-1.419-0.323-2.532-1.454-2.532c-1.13,0-1.453,1.113-1.453,2.532
                    c0,1.429,0.323,2.542,1.453,2.542C365.59,23.594,365.914,22.481,365.914,21.052z"
                ></path>
            </g>
            <g
                style="enable-background: new"
                transform="matrix(1, 0, 0, 1, 3, 0)"
            >
                <path
                    d="M447.178,22.88c0,0,0.45,0.705,1.385,0.705c0.851,0,1.487-0.604,1.487-1.394c0-0.824-0.688-1.402-1.547-1.402
                    c-0.671,0-1.147,0.331-1.147,0.331l-0.306-0.127l0.255-2.405c0.034-0.366,0.153-0.519,0.519-0.519h1.964
                    c0.356,0,0.51,0.152,0.51,0.519v0.595h-0.553v-0.399c0-0.128-0.068-0.188-0.187-0.188h-1.514c-0.118,0-0.17,0.06-0.187,0.188
                    l-0.153,1.352c-0.025,0.212-0.051,0.34-0.051,0.34h0.017c0,0,0.374-0.222,0.901-0.222c1.216,0,2.091,0.867,2.091,1.946
                    c0,1.062-0.884,1.946-2.1,1.946c-1.189,0-1.759-0.85-1.759-0.85L447.178,22.88z"
                ></path>
                <path
                    d="M451.623,21.052c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    S451.623,22.786,451.623,21.052z M455.133,21.052c0-1.419-0.323-2.532-1.453-2.532c-1.131,0-1.453,1.113-1.453,2.532
                    c0,1.429,0.322,2.542,1.453,2.542C454.81,23.594,455.133,22.481,455.133,21.052z"
                ></path>
            </g>
        </g>
        } @if (showUnits) {
        <g id="units">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M16.672,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M25.594,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M34.516,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M43.438,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M61.282,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M70.204,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M52.36,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M79.126,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M88.048,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M105.892,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M114.814,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M123.736,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M132.658,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M150.502,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M159.423,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M141.58,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M168.345,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M177.267,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M195.111,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M204.033,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M212.955,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M221.877,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M239.721,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M248.643,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M230.799,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M257.565,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M266.487,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M284.331,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M293.253,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M302.175,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M311.097,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M328.941,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M337.863,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M320.019,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M346.785,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M355.707,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M373.551,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M382.473,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M391.395,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M400.317,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M418.161,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M427.083,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M409.239,3.189v7.795"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M436.005,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M444.927,4.252v5.669"
            />
        </g>
        }
    </svg>
</ng-template>

<!-- 0-100 -->
<ng-template #numberLine_0_100>
    <svg
        version="1.1"
        id="numberLine_0_100"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 461.497 25.917"
        style="enable-background: new 0 0 461.497 25.917"
        xml:space="preserve"
    >
        <g id="line">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M7.75,0v14.031"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M0,6.945h461.497"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M453.85,0v14.031"
            />
        </g>

        @if (showMarkers) {
        <g id="markers">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M52.36,0v14.031"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M96.97,0v14.031"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M141.58,0v14.031"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M186.19,0v14.031"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M230.8,0v14.031"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M275.41,0v14.031"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M320.02,0v14.031"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M364.63,0v14.031"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M409.24,0v14.031"
            />
        </g>
        } @if (showNumbers) {
        <g id="numbers">
            <g style="enable-background: new">
                <path
                    d="M5.693,20.911c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
			C6.194,24.005,5.693,22.645,5.693,20.911z M9.203,20.911c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
			c0,1.428,0.323,2.541,1.453,2.541S9.203,22.339,9.203,20.911z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M48.386,23.376h1.334V18.99c0-0.17,0.008-0.332,0.008-0.332h-0.017c0,0-0.059,0.127-0.297,0.357l-0.637,0.638l-0.374-0.382
			l1.351-1.343h0.561v5.448h1.309v0.527h-3.238V23.376z"
                />
                <path
                    d="M52.262,20.911c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
			C52.764,24.005,52.262,22.645,52.262,20.911z M55.772,20.911c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
			c0,1.428,0.323,2.541,1.453,2.541S55.772,22.339,55.772,20.911z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M95.555,19.508c0-0.638-0.467-1.122-1.224-1.122c-0.595,0-1.062,0.306-1.062,0.646v0.281h-0.561v-0.442
			c0-0.756,1.028-1.045,1.641-1.045c1.139,0,1.818,0.748,1.818,1.674c0,2.099-3.162,2.048-3.162,3.706c0,0.119,0.068,0.17,0.196,0.17
			h2.499c0.119,0,0.187-0.06,0.187-0.187v-0.399h0.552v0.595c0,0.366-0.153,0.519-0.518,0.519h-2.992
			c-0.408,0-0.536-0.17-0.536-0.586C92.393,21.098,95.555,21.276,95.555,19.508z"
                />
                <path
                    d="M97.289,20.911c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
			C97.79,24.005,97.289,22.645,97.289,20.911z M100.799,20.911c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
			c0,1.428,0.323,2.541,1.453,2.541S100.799,22.339,100.799,20.911z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M137.356,22.73c0,0,0.612,0.714,1.563,0.714c0.706,0,1.352-0.527,1.352-1.292c0-0.807-0.697-1.258-1.453-1.258h-0.417
			l-0.136-0.348l1.47-1.768c0.145-0.195,0.306-0.332,0.306-0.332v-0.017c0,0-0.17,0.026-0.484,0.026h-1.556
			c-0.119,0-0.187,0.059-0.187,0.187v0.399h-0.553v-0.595c0-0.365,0.136-0.519,0.501-0.519h3.034v0.391l-1.759,2.065
			c0.748,0.042,1.844,0.476,1.844,1.759c0,1.011-0.841,1.861-1.972,1.861c-1.181,0-1.912-0.833-1.912-0.833L137.356,22.73z"
                />
                <path
                    d="M141.767,20.911c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
			C142.268,24.005,141.767,22.645,141.767,20.911z M145.277,20.911c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
			c0,1.428,0.323,2.541,1.453,2.541S145.277,22.339,145.277,20.911z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M181.371,21.863l2.907-3.936h0.637v3.799h0.952v0.527h-0.952v1.649h-0.595v-1.649h-2.949V21.863z M184.328,19.287
			c0-0.255,0.026-0.578,0.026-0.578h-0.017c0,0-0.145,0.247-0.306,0.459l-1.657,2.193c-0.162,0.212-0.314,0.374-0.314,0.374v0.017
			c0,0,0.238-0.025,0.493-0.025h1.776V19.287z"
                />
                <path
                    d="M186.521,20.911c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
			C187.023,24.005,186.521,22.645,186.521,20.911z M190.032,20.911c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
			c0,1.428,0.323,2.541,1.453,2.541S190.032,22.339,190.032,20.911z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M226.686,22.738c0,0,0.45,0.706,1.385,0.706c0.85,0,1.487-0.604,1.487-1.394c0-0.824-0.688-1.402-1.547-1.402
			c-0.671,0-1.147,0.332-1.147,0.332l-0.306-0.127l0.255-2.405c0.034-0.365,0.153-0.519,0.519-0.519h1.963
			c0.357,0,0.51,0.153,0.51,0.519v0.595h-0.552v-0.399c0-0.128-0.068-0.187-0.187-0.187h-1.513c-0.119,0-0.17,0.059-0.187,0.187
			l-0.153,1.351c-0.025,0.212-0.051,0.34-0.051,0.34h0.017c0,0,0.374-0.221,0.901-0.221c1.216,0,2.091,0.867,2.091,1.946
			c0,1.062-0.884,1.946-2.099,1.946c-1.19,0-1.759-0.85-1.759-0.85L226.686,22.738z"
                />
                <path
                    d="M231.132,20.911c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
			C231.633,24.005,231.132,22.645,231.132,20.911z M234.642,20.911c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
			c0,1.428,0.323,2.541,1.453,2.541S234.642,22.339,234.642,20.911z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M270.871,21.276c0-1.521,0.782-3.45,2.626-3.45c0.654,0,1.097,0.246,1.097,0.246l-0.221,0.519
			c0,0-0.374-0.212-0.867-0.212c-1.249,0-1.887,1.25-1.997,2.456h0.017c0.28-0.467,0.901-0.722,1.521-0.722
			c1.088,0,1.861,0.782,1.861,1.895c0,1.241-0.833,1.998-1.878,1.998C271.729,24.005,270.871,22.84,270.871,21.276z M273.021,23.452
			c0.808,0,1.283-0.612,1.283-1.436c0-0.833-0.535-1.377-1.352-1.377c-0.799,0-1.444,0.536-1.444,1.02
			C271.508,22.449,272.128,23.452,273.021,23.452z"
                />
                <path
                    d="M275.699,20.911c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
			S275.699,22.645,275.699,20.911z M279.208,20.911c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.453,1.113-1.453,2.533
			c0,1.428,0.322,2.541,1.453,2.541C278.885,23.452,279.208,22.339,279.208,20.911z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M318.642,19.007c0.171-0.323,0.332-0.552,0.332-0.552v-0.017c0,0-0.153,0.017-0.45,0.017h-2.15
			c-0.119,0-0.188,0.059-0.188,0.187v0.399h-0.561v-0.595c0-0.365,0.145-0.519,0.51-0.519h3.527v0.408l-2.958,5.567h-0.663
			L318.642,19.007z"
                />
                <path
                    d="M320.054,20.911c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
			S320.054,22.645,320.054,20.911z M323.564,20.911c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.453,1.113-1.453,2.533
			c0,1.428,0.322,2.541,1.453,2.541C323.241,23.452,323.564,22.339,323.564,20.911z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M361.158,20.639v-0.017c0,0-0.816-0.382-0.816-1.232c0-0.824,0.646-1.563,1.802-1.563c1.131,0,1.827,0.663,1.827,1.589
			c0,0.91-0.799,1.479-0.799,1.479v0.017c0.562,0.289,0.961,0.671,0.961,1.368c0,0.935-0.867,1.726-2.006,1.726
			c-1.054,0-2.031-0.654-2.031-1.785C360.095,21.174,361.158,20.639,361.158,20.639z M362.126,23.452
			c0.705,0,1.394-0.484,1.394-1.181c0-0.621-0.51-0.867-1.139-1.122c-0.221-0.093-0.629-0.238-0.697-0.238
			c-0.229,0-0.978,0.544-0.978,1.283C360.706,22.976,361.395,23.452,362.126,23.452z M362.62,20.639
			c0.212,0,0.756-0.586,0.756-1.207c0-0.646-0.51-1.054-1.232-1.054c-0.756,0-1.207,0.45-1.207,1.011
			c0,0.629,0.527,0.858,1.147,1.088C362.22,20.528,362.508,20.639,362.62,20.639z"
                />
                <path
                    d="M364.949,20.911c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
			S364.949,22.645,364.949,20.911z M368.458,20.911c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.453,1.113-1.453,2.533
			c0,1.428,0.322,2.541,1.453,2.541C368.135,23.452,368.458,22.339,368.458,20.911z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M405.214,23.239c0,0,0.374,0.212,0.867,0.212c1.249,0,1.896-1.258,1.997-2.464h-0.017
			c-0.281,0.467-0.901,0.731-1.521,0.731c-1.088,0-1.854-0.782-1.854-1.896c0-1.241,0.825-1.997,1.87-1.997
			c1.301,0,2.159,1.164,2.159,2.728c0,1.521-0.773,3.451-2.626,3.451c-0.655,0-1.097-0.247-1.097-0.247L405.214,23.239z
			 M408.079,20.172c0-0.791-0.62-1.793-1.513-1.793c-0.808,0-1.283,0.612-1.283,1.437c0,0.833,0.535,1.376,1.352,1.376
			C407.433,21.191,408.079,20.656,408.079,20.172z"
                />
                <path
                    d="M409.54,20.911c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
			C410.042,24.005,409.54,22.645,409.54,20.911z M413.051,20.911c0-1.419-0.323-2.533-1.454-2.533c-1.13,0-1.453,1.113-1.453,2.533
			c0,1.428,0.323,2.541,1.453,2.541C412.728,23.452,413.051,22.339,413.051,20.911z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M447.318,23.376h1.334V18.99c0-0.17,0.009-0.332,0.009-0.332h-0.018c0,0-0.059,0.127-0.297,0.357l-0.638,0.638
			l-0.374-0.382l1.352-1.343h0.561v5.448h1.31v0.527h-3.238V23.376z"
                />
                <path
                    d="M451.194,20.911c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
			S451.194,22.645,451.194,20.911z M454.704,20.911c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.453,1.113-1.453,2.533
			c0,1.428,0.322,2.541,1.453,2.541C454.38,23.452,454.704,22.339,454.704,20.911z"
                />
                <path
                    d="M456.31,20.911c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
			C456.812,24.005,456.31,22.645,456.31,20.911z M459.821,20.911c0-1.419-0.323-2.533-1.454-2.533c-1.13,0-1.453,1.113-1.453,2.533
			c0,1.428,0.323,2.541,1.453,2.541C459.497,23.452,459.821,22.339,459.821,20.911z"
                />
            </g>
        </g>
        } @if (showUnits) {
        <g id="units">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M12.211,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M16.672,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M21.133,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M25.594,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M34.516,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M38.977,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M30.055,2.693v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M43.438,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M47.899,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M56.821,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M61.282,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M65.743,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M70.204,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M79.126,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M83.587,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M74.665,2.693v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M88.048,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M92.508,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M101.43,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M105.892,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M110.353,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M114.813,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M123.735,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M128.197,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M119.274,2.693v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M132.658,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M137.118,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M146.04,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M150.501,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M154.962,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M159.423,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M168.346,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M172.807,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M163.885,2.693v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M177.268,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M181.729,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M190.65,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M195.111,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M199.572,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M204.033,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M212.956,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M217.417,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M208.495,3.047v7.795"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M221.878,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M226.339,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M235.26,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M239.721,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M244.182,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M248.643,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M257.565,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M262.026,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M253.104,2.693v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M266.487,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M270.948,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M279.87,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M284.332,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M288.793,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M293.254,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M302.176,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M306.636,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M297.715,2.693v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M311.097,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M315.558,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M324.48,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M328.941,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M333.402,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M337.863,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M346.785,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M351.246,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M342.324,2.693v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M355.707,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M360.168,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M369.09,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M373.551,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M378.012,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M382.473,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M391.395,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M395.856,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M386.934,2.693v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M400.317,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M404.778,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M413.7,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M418.161,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M422.622,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M427.083,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M436.005,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M440.466,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M431.544,3.047v7.795"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M444.927,4.11v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M449.388,4.11v5.669"
            />
        </g>
        }
    </svg>
</ng-template>

<!-- 0-500 -->
<ng-template #numberLine_0_500>
    <svg
        version="1.1"
        id="numberLine_0_500"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 461.497 26.059"
        style="enable-background: new 0 0 461.497 26.059"
        xml:space="preserve"
    >
        <g id="line">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M7.75,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M0,7.087h461.497"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M453.85,0v14.173"
            />
        </g>
        @if (showMarkers) {
        <g id="markers">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M96.97,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M186.19,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M275.41,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M364.63,0v14.173"
            />
        </g>
        } @if (showNumbers) {
        <g id="numbers">
            <g style="enable-background: new">
                <path
                    d="M5.693,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    C6.194,24.146,5.693,22.786,5.693,21.052z M9.203,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                    c0,1.429,0.323,2.542,1.453,2.542S9.203,22.481,9.203,21.052z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M90.438,23.517h1.334v-4.385c0-0.17,0.008-0.332,0.008-0.332h-0.017c0,0-0.059,0.128-0.297,0.357l-0.637,0.637
                    l-0.374-0.382l1.351-1.343h0.561v5.447h1.309v0.527h-3.238V23.517z"
                />
                <path
                    d="M94.314,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    C94.815,24.146,94.314,22.786,94.314,21.052z M97.824,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                    c0,1.429,0.323,2.542,1.453,2.542S97.824,22.481,97.824,21.052z"
                />
                <path
                    d="M99.431,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    C99.932,24.146,99.431,22.786,99.431,21.052z M102.941,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                    c0,1.429,0.323,2.542,1.453,2.542S102.941,22.481,102.941,21.052z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M182.216,19.65c0-0.637-0.467-1.121-1.224-1.121c-0.595,0-1.062,0.306-1.062,0.646v0.28h-0.561v-0.441
                    c0-0.757,1.028-1.046,1.641-1.046c1.139,0,1.818,0.748,1.818,1.675c0,2.099-3.162,2.048-3.162,3.705c0,0.119,0.068,0.17,0.196,0.17
                    h2.499c0.119,0,0.187-0.06,0.187-0.187v-0.399h0.552v0.595c0,0.365-0.153,0.519-0.518,0.519h-2.992
                    c-0.408,0-0.536-0.17-0.536-0.587C179.054,21.24,182.216,21.418,182.216,19.65z"
                />
                <path
                    d="M183.95,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    C184.452,24.146,183.95,22.786,183.95,21.052z M187.46,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                    c0,1.429,0.323,2.542,1.453,2.542S187.46,22.481,187.46,21.052z"
                />
                <path
                    d="M189.067,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    C189.568,24.146,189.067,22.786,189.067,21.052z M192.577,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                    c0,1.429,0.323,2.542,1.453,2.542S192.577,22.481,192.577,21.052z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M268.627,22.871c0,0,0.611,0.714,1.563,0.714c0.705,0,1.352-0.527,1.352-1.292c0-0.808-0.697-1.258-1.454-1.258h-0.416
                    l-0.136-0.349l1.47-1.768c0.145-0.195,0.307-0.331,0.307-0.331v-0.018c0,0-0.17,0.025-0.484,0.025h-1.556
                    c-0.119,0-0.187,0.06-0.187,0.188v0.399h-0.553v-0.595c0-0.366,0.136-0.519,0.501-0.519h3.034v0.391l-1.759,2.065
                    c0.748,0.042,1.844,0.476,1.844,1.759c0,1.012-0.841,1.861-1.972,1.861c-1.182,0-1.912-0.832-1.912-0.832L268.627,22.871z"
                />
                <path
                    d="M273.039,21.052c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    S273.039,22.786,273.039,21.052z M276.548,21.052c0-1.419-0.323-2.532-1.453-2.532c-1.131,0-1.453,1.113-1.453,2.532
                    c0,1.429,0.322,2.542,1.453,2.542C276.225,23.594,276.548,22.481,276.548,21.052z"
                />
                <path
                    d="M278.155,21.052c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    C278.657,24.146,278.155,22.786,278.155,21.052z M281.665,21.052c0-1.419-0.323-2.532-1.454-2.532c-1.13,0-1.453,1.113-1.453,2.532
                    c0,1.429,0.323,2.542,1.453,2.542C281.342,23.594,281.665,22.481,281.665,21.052z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M357.252,22.004l2.906-3.935h0.638v3.799h0.952v0.527h-0.952v1.648h-0.595v-1.648h-2.949V22.004z M360.209,19.429
                    c0-0.255,0.026-0.578,0.026-0.578h-0.018c0,0-0.145,0.247-0.306,0.459l-1.657,2.193c-0.162,0.212-0.314,0.374-0.314,0.374v0.017
                    c0,0,0.237-0.025,0.493-0.025h1.775V19.429z"
                />
                <path
                    d="M362.403,21.052c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    C362.905,24.146,362.403,22.786,362.403,21.052z M365.914,21.052c0-1.419-0.323-2.532-1.454-2.532c-1.13,0-1.453,1.113-1.453,2.532
                    c0,1.429,0.323,2.542,1.453,2.542C365.59,23.594,365.914,22.481,365.914,21.052z"
                />
                <path
                    d="M367.52,21.052c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    S367.52,22.786,367.52,21.052z M371.03,21.052c0-1.419-0.323-2.532-1.453-2.532c-1.131,0-1.453,1.113-1.453,2.532
                    c0,1.429,0.322,2.542,1.453,2.542C370.706,23.594,371.03,22.481,371.03,21.052z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M447.178,22.88c0,0,0.45,0.705,1.385,0.705c0.851,0,1.487-0.604,1.487-1.394c0-0.824-0.688-1.402-1.547-1.402
                    c-0.671,0-1.147,0.331-1.147,0.331l-0.306-0.127l0.255-2.405c0.034-0.366,0.153-0.519,0.519-0.519h1.964
                    c0.356,0,0.51,0.152,0.51,0.519v0.595h-0.553v-0.399c0-0.128-0.068-0.188-0.187-0.188h-1.514c-0.118,0-0.17,0.06-0.187,0.188
                    l-0.153,1.352c-0.025,0.212-0.051,0.34-0.051,0.34h0.017c0,0,0.374-0.222,0.901-0.222c1.216,0,2.091,0.867,2.091,1.946
                    c0,1.062-0.884,1.946-2.1,1.946c-1.189,0-1.759-0.85-1.759-0.85L447.178,22.88z"
                />
                <path
                    d="M451.623,21.052c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    S451.623,22.786,451.623,21.052z M455.133,21.052c0-1.419-0.323-2.532-1.453-2.532c-1.131,0-1.453,1.113-1.453,2.532
                    c0,1.429,0.322,2.542,1.453,2.542C454.81,23.594,455.133,22.481,455.133,21.052z"
                />
                <path
                    d="M456.74,21.052c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                    C457.242,24.146,456.74,22.786,456.74,21.052z M460.25,21.052c0-1.419-0.323-2.532-1.454-2.532c-1.13,0-1.453,1.113-1.453,2.532
                    c0,1.429,0.323,2.542,1.453,2.542C459.927,23.594,460.25,22.481,460.25,21.052z"
                />
            </g>
        </g>
        } @if (showUnits) {
        <g id="units">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M16.672,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M25.594,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M34.516,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M43.438,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M61.282,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M70.204,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M52.36,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M79.126,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M88.048,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M105.892,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M114.814,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M123.736,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M132.658,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M150.502,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M159.423,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M141.58,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M168.345,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M177.267,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M195.111,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M204.033,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M212.955,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M221.877,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M239.721,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M248.643,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M230.799,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M257.565,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M266.487,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M284.331,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M293.253,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M302.175,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M311.097,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M328.941,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M337.863,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M320.019,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M346.785,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M355.707,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M373.551,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M382.473,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M391.395,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M400.317,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M418.161,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M427.083,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M409.239,3.189v7.795"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M436.005,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M444.927,4.252v5.669"
            />
        </g>
        }
    </svg>
</ng-template>

<!-- 0-1000 -->
<ng-template #numberLine_0_1000>
    <svg
        version="1.1"
        id="numberLine_0_1000"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 463.485 26.059"
        style="enable-background: new 0 0 463.485 26.059"
        xml:space="preserve"
    >
        <g id="line">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M7.75,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M0,7.087h461.497"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M453.848,0v14.173"
            />
        </g>

        @if (showMarkers) {
        <g id="markers">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M52.36,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M96.97,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M141.579,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M186.189,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M230.799,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M275.409,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M320.019,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M364.628,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M409.238,0v14.173"
            />
        </g>
        } @if (showNumbers) {
        <g id="numbers">
            <g style="enable-background: new">
                <path
                    d="M5.693,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C6.194,24.146,5.693,22.786,5.693,21.053z M9.203,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
	c0,1.428,0.323,2.541,1.453,2.541S9.203,22.48,9.203,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M45.828,23.517h1.334v-4.386c0-0.17,0.008-0.332,0.008-0.332h-0.017c0,0-0.059,0.127-0.297,0.357l-0.637,0.638
	l-0.374-0.382l1.351-1.343h0.561v5.448h1.309v0.527h-3.238V23.517z"
                />
                <path
                    d="M49.704,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C50.205,24.146,49.704,22.786,49.704,21.053z M53.214,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
	c0,1.428,0.323,2.541,1.453,2.541S53.214,22.48,53.214,21.053z"
                />
                <path
                    d="M54.82,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C55.322,24.146,54.82,22.786,54.82,21.053z M58.331,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
	c0,1.428,0.323,2.541,1.453,2.541S58.331,22.48,58.331,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M92.996,19.65c0-0.638-0.467-1.122-1.224-1.122c-0.595,0-1.062,0.306-1.062,0.646v0.281h-0.561v-0.442
	c0-0.756,1.028-1.045,1.641-1.045c1.139,0,1.818,0.748,1.818,1.674c0,2.099-3.162,2.048-3.162,3.706c0,0.119,0.068,0.17,0.196,0.17
	h2.499c0.119,0,0.187-0.06,0.187-0.187v-0.399h0.552v0.595c0,0.366-0.153,0.519-0.518,0.519H90.37c-0.408,0-0.536-0.17-0.536-0.586
	C89.834,21.24,92.996,21.418,92.996,19.65z"
                />
                <path
                    d="M94.73,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C95.232,24.146,94.73,22.786,94.73,21.053z M98.241,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
	c0,1.428,0.323,2.541,1.453,2.541S98.241,22.48,98.241,21.053z"
                />
                <path
                    d="M99.847,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C100.349,24.146,99.847,22.786,99.847,21.053z M103.357,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
	c0,1.428,0.323,2.541,1.453,2.541S103.357,22.48,103.357,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M134.797,22.871c0,0,0.612,0.714,1.563,0.714c0.706,0,1.352-0.527,1.352-1.292c0-0.807-0.697-1.258-1.453-1.258h-0.417
	l-0.136-0.348l1.47-1.768c0.145-0.195,0.306-0.332,0.306-0.332v-0.017c0,0-0.17,0.026-0.484,0.026h-1.556
	c-0.119,0-0.187,0.059-0.187,0.187v0.399h-0.553v-0.595c0-0.365,0.136-0.519,0.501-0.519h3.034v0.391l-1.759,2.065
	c0.748,0.042,1.844,0.476,1.844,1.759c0,1.011-0.841,1.861-1.972,1.861c-1.181,0-1.912-0.833-1.912-0.833L134.797,22.871z"
                />
                <path
                    d="M139.208,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C139.71,24.146,139.208,22.786,139.208,21.053z M142.719,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
	c0,1.428,0.323,2.541,1.453,2.541S142.719,22.48,142.719,21.053z"
                />
                <path
                    d="M144.325,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C144.827,24.146,144.325,22.786,144.325,21.053z M147.835,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
	c0,1.428,0.323,2.541,1.453,2.541S147.835,22.48,147.835,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M178.812,22.005l2.907-3.936h0.637v3.799h0.952v0.527h-0.952v1.649h-0.595v-1.649h-2.949V22.005z M181.769,19.429
	c0-0.255,0.026-0.578,0.026-0.578h-0.017c0,0-0.145,0.247-0.306,0.459l-1.657,2.193c-0.162,0.212-0.314,0.374-0.314,0.374v0.017
	c0,0,0.238-0.025,0.493-0.025h1.776V19.429z"
                />
                <path
                    d="M183.963,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C184.464,24.146,183.963,22.786,183.963,21.053z M187.473,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
	c0,1.428,0.323,2.541,1.453,2.541S187.473,22.48,187.473,21.053z"
                />
                <path
                    d="M189.08,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C189.581,24.146,189.08,22.786,189.08,21.053z M192.59,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
	c0,1.428,0.323,2.541,1.453,2.541S192.59,22.48,192.59,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M224.128,22.88c0,0,0.45,0.706,1.385,0.706c0.85,0,1.487-0.604,1.487-1.394c0-0.824-0.688-1.402-1.547-1.402
	c-0.671,0-1.147,0.332-1.147,0.332L224,20.993l0.255-2.405c0.034-0.365,0.153-0.519,0.519-0.519h1.963
	c0.357,0,0.51,0.153,0.51,0.519v0.595h-0.552v-0.399c0-0.128-0.068-0.187-0.187-0.187h-1.513c-0.119,0-0.17,0.059-0.187,0.187
	l-0.153,1.351c-0.025,0.212-0.051,0.34-0.051,0.34h0.017c0,0,0.374-0.221,0.901-0.221c1.216,0,2.091,0.867,2.091,1.946
	c0,1.062-0.884,1.946-2.099,1.946c-1.19,0-1.759-0.85-1.759-0.85L224.128,22.88z"
                />
                <path
                    d="M228.573,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C229.075,24.146,228.573,22.786,228.573,21.053z M232.083,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
	c0,1.428,0.323,2.541,1.453,2.541S232.083,22.48,232.083,21.053z"
                />
                <path
                    d="M233.69,21.053c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C234.191,24.146,233.69,22.786,233.69,21.053z M237.2,21.053c0-1.419-0.323-2.533-1.454-2.533s-1.453,1.113-1.453,2.533
	c0,1.428,0.323,2.541,1.453,2.541S237.2,22.48,237.2,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M268.312,21.418c0-1.521,0.782-3.45,2.626-3.45c0.654,0,1.097,0.246,1.097,0.246l-0.221,0.519
	c0,0-0.374-0.212-0.867-0.212c-1.249,0-1.887,1.25-1.997,2.456h0.017c0.28-0.467,0.901-0.722,1.521-0.722
	c1.088,0,1.861,0.782,1.861,1.895c0,1.241-0.833,1.998-1.878,1.998C269.17,24.146,268.312,22.982,268.312,21.418z M270.462,23.594
	c0.808,0,1.283-0.612,1.283-1.436c0-0.833-0.535-1.377-1.352-1.377c-0.799,0-1.444,0.536-1.444,1.02
	C268.95,22.591,269.57,23.594,270.462,23.594z"
                />
                <path
                    d="M273.14,21.053c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	S273.14,22.786,273.14,21.053z M276.65,21.053c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.453,1.113-1.453,2.533
	c0,1.428,0.322,2.541,1.453,2.541C276.327,23.594,276.65,22.48,276.65,21.053z"
                />
                <path
                    d="M278.256,21.053c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C278.758,24.146,278.256,22.786,278.256,21.053z M281.767,21.053c0-1.419-0.323-2.533-1.454-2.533
	c-1.13,0-1.453,1.113-1.453,2.533c0,1.428,0.323,2.541,1.453,2.541C281.444,23.594,281.767,22.48,281.767,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M316.083,19.149c0.171-0.323,0.332-0.552,0.332-0.552v-0.017c0,0-0.153,0.017-0.45,0.017h-2.15
	c-0.119,0-0.188,0.059-0.188,0.187v0.399h-0.561v-0.595c0-0.365,0.145-0.519,0.51-0.519h3.527v0.408l-2.958,5.567h-0.663
	L316.083,19.149z"
                />
                <path
                    d="M317.496,21.053c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	S317.496,22.786,317.496,21.053z M321.005,21.053c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.453,1.113-1.453,2.533
	c0,1.428,0.322,2.541,1.453,2.541C320.682,23.594,321.005,22.48,321.005,21.053z"
                />
                <path
                    d="M322.612,21.053c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C323.114,24.146,322.612,22.786,322.612,21.053z M326.122,21.053c0-1.419-0.323-2.533-1.454-2.533
	c-1.13,0-1.453,1.113-1.453,2.533c0,1.428,0.323,2.541,1.453,2.541C325.799,23.594,326.122,22.48,326.122,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M358.599,20.781v-0.017c0,0-0.816-0.382-0.816-1.232c0-0.824,0.646-1.563,1.802-1.563c1.131,0,1.827,0.663,1.827,1.589
	c0,0.91-0.799,1.479-0.799,1.479v0.017c0.562,0.289,0.961,0.671,0.961,1.368c0,0.935-0.867,1.726-2.006,1.726
	c-1.054,0-2.031-0.654-2.031-1.785C357.537,21.316,358.599,20.781,358.599,20.781z M359.568,23.594
	c0.705,0,1.394-0.484,1.394-1.181c0-0.621-0.51-0.867-1.139-1.122c-0.221-0.093-0.629-0.238-0.697-0.238
	c-0.229,0-0.978,0.544-0.978,1.283C358.148,23.118,358.836,23.594,359.568,23.594z M360.061,20.781
	c0.212,0,0.756-0.586,0.756-1.207c0-0.646-0.51-1.054-1.232-1.054c-0.756,0-1.207,0.45-1.207,1.011
	c0,0.629,0.527,0.858,1.147,1.088C359.662,20.67,359.95,20.781,360.061,20.781z"
                />
                <path
                    d="M362.39,21.053c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	S362.39,22.786,362.39,21.053z M365.9,21.053c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.453,1.113-1.453,2.533
	c0,1.428,0.322,2.541,1.453,2.541C365.577,23.594,365.9,22.48,365.9,21.053z"
                />
                <path
                    d="M367.506,21.053c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C368.008,24.146,367.506,22.786,367.506,21.053z M371.017,21.053c0-1.419-0.323-2.533-1.454-2.533
	c-1.13,0-1.453,1.113-1.453,2.533c0,1.428,0.323,2.541,1.453,2.541C370.694,23.594,371.017,22.48,371.017,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M402.657,23.381c0,0,0.374,0.212,0.866,0.212c1.25,0,1.896-1.258,1.998-2.464h-0.018c-0.28,0.467-0.9,0.731-1.521,0.731
	c-1.088,0-1.853-0.782-1.853-1.896c0-1.241,0.824-1.997,1.87-1.997c1.3,0,2.158,1.164,2.158,2.728
	c0,1.521-0.773,3.451-2.626,3.451c-0.654,0-1.097-0.247-1.097-0.247L402.657,23.381z M405.521,20.313
	c0-0.791-0.621-1.793-1.514-1.793c-0.807,0-1.283,0.612-1.283,1.437c0,0.833,0.536,1.376,1.352,1.376
	C404.874,21.333,405.521,20.798,405.521,20.313z"
                />
                <path
                    d="M406.983,21.053c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	S406.983,22.786,406.983,21.053z M410.493,21.053c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.453,1.113-1.453,2.533
	c0,1.428,0.322,2.541,1.453,2.541C410.169,23.594,410.493,22.48,410.493,21.053z"
                />
                <path
                    d="M412.099,21.053c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C412.601,24.146,412.099,22.786,412.099,21.053z M415.61,21.053c0-1.419-0.323-2.533-1.454-2.533c-1.13,0-1.453,1.113-1.453,2.533
	c0,1.428,0.323,2.541,1.453,2.541C415.287,23.594,415.61,22.48,415.61,21.053z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M444.759,23.517h1.334v-4.386c0-0.17,0.009-0.332,0.009-0.332h-0.018c0,0-0.059,0.127-0.297,0.357l-0.638,0.638
	l-0.374-0.382l1.352-1.343h0.561v5.448h1.31v0.527h-3.238V23.517z"
                />
                <path
                    d="M448.635,21.053c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	S448.635,22.786,448.635,21.053z M452.145,21.053c0-1.419-0.323-2.533-1.453-2.533c-1.131,0-1.453,1.113-1.453,2.533
	c0,1.428,0.322,2.541,1.453,2.541C451.822,23.594,452.145,22.48,452.145,21.053z"
                />
                <path
                    d="M453.751,21.053c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	C454.253,24.146,453.751,22.786,453.751,21.053z M457.262,21.053c0-1.419-0.323-2.533-1.454-2.533
	c-1.13,0-1.453,1.113-1.453,2.533c0,1.428,0.323,2.541,1.453,2.541C456.939,23.594,457.262,22.48,457.262,21.053z"
                />
                <path
                    d="M458.869,21.053c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
	S458.869,22.786,458.869,21.053z M462.378,21.053c0-1.419-0.322-2.533-1.453-2.533s-1.453,1.113-1.453,2.533
	c0,1.428,0.322,2.541,1.453,2.541S462.378,22.48,462.378,21.053z"
                />
            </g>
        </g>
        } @if (showUnits) {
        <g id="units">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M12.211,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M16.672,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M21.133,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M25.594,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M34.516,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M38.977,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M30.055,1.418v9.921"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M43.438,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M47.899,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M56.821,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M61.282,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M65.743,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M70.204,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M79.126,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M83.587,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M74.665,1.418v9.921"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M88.048,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M92.508,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M101.43,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M105.892,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M110.353,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M114.813,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M123.735,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M128.197,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M119.274,1.418v9.921"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M132.658,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M137.118,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M146.04,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M150.501,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M154.962,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M159.423,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M168.346,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M172.807,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M163.885,1.418v9.921"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M177.268,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M181.729,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M190.65,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M195.111,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M199.572,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M204.033,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M212.956,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M217.417,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M208.495,1.772v9.212"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M221.878,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M226.339,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M235.26,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M239.721,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M244.182,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M248.643,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M257.565,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M262.026,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M253.104,1.418v9.921"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M266.487,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M270.948,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M279.87,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M284.332,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M288.793,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M293.254,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M302.176,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M306.636,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M297.715,1.418v9.921"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M311.097,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M315.558,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M324.48,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M328.941,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M333.402,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M337.863,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M346.785,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M351.246,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M342.324,1.418v9.921"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M355.707,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M360.168,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M369.09,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M373.551,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M378.012,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M382.473,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M391.395,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M395.856,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M386.934,1.418v9.921"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M400.317,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M404.778,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M413.7,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M418.161,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M422.622,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M427.083,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M436.005,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M440.466,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M431.544,1.772v9.212"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M444.927,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M449.388,4.252v5.669"
            />
        </g>
        }
    </svg>
</ng-template>

<!-- 500-1000 -->
<ng-template #numberLine_500_1000>
    <svg
        version="1.1"
        id="numberLine_500_1000"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 463.485 26.059"
        style="enable-background: new 0 0 463.485 26.059"
        xml:space="preserve"
    >
        <g id="line">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M7.75,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M0,7.087h461.497"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M453.85,0v14.173"
            />
        </g>
        @if (showMarkers) {
        <g id="markers">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M96.97,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M186.19,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M275.41,0v14.173"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M364.63,0v14.173"
            />
        </g>
        } @if (showNumbers) {
        <g id="numbers">
            <g style="enable-background: new">
                <path
                    d="M1.078,22.88c0,0,0.45,0.705,1.385,0.705c0.85,0,1.487-0.604,1.487-1.394c0-0.824-0.688-1.402-1.547-1.402
                c-0.671,0-1.147,0.331-1.147,0.331L0.95,20.993l0.255-2.405c0.034-0.366,0.153-0.519,0.519-0.519h1.963
                c0.357,0,0.51,0.152,0.51,0.519v0.595H3.644v-0.399c0-0.128-0.068-0.188-0.187-0.188H1.944c-0.119,0-0.17,0.06-0.187,0.188
                l-0.153,1.352c-0.025,0.212-0.051,0.34-0.051,0.34H1.57c0,0,0.374-0.222,0.901-0.222c1.216,0,2.091,0.867,2.091,1.946
                c0,1.062-0.884,1.946-2.099,1.946c-1.19,0-1.759-0.85-1.759-0.85L1.078,22.88z"
                />
                <path
                    d="M5.523,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C6.024,24.146,5.523,22.786,5.523,21.052z M9.033,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                c0,1.429,0.323,2.542,1.453,2.542S9.033,22.481,9.033,21.052z"
                />
                <path
                    d="M10.64,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C11.141,24.146,10.64,22.786,10.64,21.052z M14.15,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                c0,1.429,0.323,2.542,1.453,2.542S14.15,22.481,14.15,21.052z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M89.872,21.418c0-1.521,0.782-3.451,2.626-3.451c0.654,0,1.096,0.247,1.096,0.247l-0.221,0.519
                c0,0-0.374-0.213-0.867-0.213c-1.249,0-1.887,1.249-1.997,2.456h0.017c0.28-0.467,0.901-0.723,1.521-0.723
                c1.088,0,1.861,0.782,1.861,1.896c0,1.241-0.833,1.997-1.878,1.997C90.731,24.146,89.872,22.982,89.872,21.418z M92.023,23.594
                c0.808,0,1.284-0.612,1.284-1.437c0-0.833-0.536-1.377-1.352-1.377c-0.799,0-1.445,0.535-1.445,1.02
                C90.51,22.591,91.131,23.594,92.023,23.594z"
                />
                <path
                    d="M94.701,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C95.202,24.146,94.701,22.786,94.701,21.052z M98.211,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                c0,1.429,0.323,2.542,1.453,2.542S98.211,22.481,98.211,21.052z"
                />
                <path
                    d="M99.817,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C100.319,24.146,99.817,22.786,99.817,21.052z M103.328,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                c0,1.429,0.323,2.542,1.453,2.542S103.328,22.481,103.328,21.052z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M182.254,19.149c0.17-0.323,0.332-0.553,0.332-0.553v-0.017c0,0-0.153,0.017-0.45,0.017h-2.15
                c-0.119,0-0.187,0.06-0.187,0.188v0.399h-0.561v-0.595c0-0.366,0.145-0.519,0.51-0.519h3.527v0.407l-2.958,5.567h-0.663
                L182.254,19.149z"
                />
                <path
                    d="M183.665,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C184.167,24.146,183.665,22.786,183.665,21.052z M187.176,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                c0,1.429,0.323,2.542,1.453,2.542S187.176,22.481,187.176,21.052z"
                />
                <path
                    d="M188.782,21.052c0-1.717,0.501-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C189.284,24.146,188.782,22.786,188.782,21.052z M192.292,21.052c0-1.419-0.323-2.532-1.454-2.532s-1.453,1.113-1.453,2.532
                c0,1.429,0.323,2.542,1.453,2.542S192.292,22.481,192.292,21.052z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M269.379,20.781v-0.017c0,0-0.816-0.383-0.816-1.232c0-0.825,0.646-1.564,1.802-1.564c1.131,0,1.827,0.663,1.827,1.59
                c0,0.909-0.799,1.479-0.799,1.479v0.017c0.562,0.289,0.961,0.672,0.961,1.369c0,0.935-0.867,1.725-2.006,1.725
                c-1.054,0-2.031-0.654-2.031-1.784C268.317,21.316,269.379,20.781,269.379,20.781z M270.348,23.594
                c0.705,0,1.394-0.484,1.394-1.182c0-0.62-0.51-0.867-1.139-1.122c-0.221-0.094-0.629-0.238-0.697-0.238
                c-0.229,0-0.978,0.545-0.978,1.284C268.928,23.117,269.617,23.594,270.348,23.594z M270.841,20.781
                c0.212,0,0.756-0.587,0.756-1.207c0-0.646-0.51-1.054-1.232-1.054c-0.756,0-1.207,0.45-1.207,1.012
                c0,0.629,0.527,0.858,1.147,1.088C270.442,20.67,270.73,20.781,270.841,20.781z"
                />
                <path
                    d="M273.17,21.052c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                S273.17,22.786,273.17,21.052z M276.68,21.052c0-1.419-0.323-2.532-1.453-2.532c-1.131,0-1.453,1.113-1.453,2.532
                c0,1.429,0.322,2.542,1.453,2.542C276.357,23.594,276.68,22.481,276.68,21.052z"
                />
                <path
                    d="M278.287,21.052c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C278.789,24.146,278.287,22.786,278.287,21.052z M281.797,21.052c0-1.419-0.323-2.532-1.454-2.532c-1.13,0-1.453,1.113-1.453,2.532
                c0,1.429,0.323,2.542,1.453,2.542C281.474,23.594,281.797,22.481,281.797,21.052z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M358.047,23.381c0,0,0.374,0.213,0.866,0.213c1.25,0,1.896-1.258,1.998-2.465h-0.018c-0.28,0.468-0.9,0.73-1.521,0.73
                c-1.088,0-1.853-0.781-1.853-1.896c0-1.24,0.824-1.997,1.87-1.997c1.3,0,2.158,1.165,2.158,2.729c0,1.521-0.773,3.45-2.626,3.45
                c-0.654,0-1.097-0.246-1.097-0.246L358.047,23.381z M360.912,20.313c0-0.79-0.621-1.793-1.514-1.793
                c-0.807,0-1.283,0.612-1.283,1.437c0,0.833,0.536,1.377,1.352,1.377C360.265,21.333,360.912,20.797,360.912,20.313z"
                />
                <path
                    d="M362.373,21.052c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                S362.373,22.786,362.373,21.052z M365.883,21.052c0-1.419-0.323-2.532-1.453-2.532c-1.131,0-1.453,1.113-1.453,2.532
                c0,1.429,0.322,2.542,1.453,2.542C365.56,23.594,365.883,22.481,365.883,21.052z"
                />
                <path
                    d="M367.49,21.052c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C367.992,24.146,367.49,22.786,367.49,21.052z M371,21.052c0-1.419-0.323-2.532-1.454-2.532c-1.13,0-1.453,1.113-1.453,2.532
                c0,1.429,0.323,2.542,1.453,2.542C370.677,23.594,371,22.481,371,21.052z"
                />
            </g>
            <g style="enable-background: new">
                <path
                    d="M444.759,23.517h1.335v-4.385c0-0.17,0.008-0.332,0.008-0.332h-0.017c0,0-0.06,0.128-0.298,0.357l-0.637,0.637
                l-0.374-0.382l1.351-1.343h0.562v5.447h1.309v0.527h-3.238V23.517z"
                />
                <path
                    d="M448.635,21.052c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C449.137,24.146,448.635,22.786,448.635,21.052z M452.146,21.052c0-1.419-0.323-2.532-1.454-2.532c-1.13,0-1.453,1.113-1.453,2.532
                c0,1.429,0.323,2.542,1.453,2.542C451.823,23.594,452.146,22.481,452.146,21.052z"
                />
                <path
                    d="M453.752,21.052c0-1.717,0.501-3.085,2.057-3.085s2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                S453.752,22.786,453.752,21.052z M457.262,21.052c0-1.419-0.323-2.532-1.453-2.532c-1.131,0-1.453,1.113-1.453,2.532
                c0,1.429,0.322,2.542,1.453,2.542C456.939,23.594,457.262,22.481,457.262,21.052z"
                />
                <path
                    d="M458.869,21.052c0-1.717,0.502-3.085,2.057-3.085c1.556,0,2.065,1.368,2.065,3.085c0,1.734-0.51,3.094-2.065,3.094
                C459.371,24.146,458.869,22.786,458.869,21.052z M462.379,21.052c0-1.419-0.323-2.532-1.454-2.532c-1.13,0-1.453,1.113-1.453,2.532
                c0,1.429,0.323,2.542,1.453,2.542C462.056,23.594,462.379,22.481,462.379,21.052z"
                />
            </g>
        </g>
        } @if (showUnits) {
        <g id="units">
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M16.672,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M25.594,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M34.516,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M43.438,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M61.282,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M70.204,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M52.36,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M79.126,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M88.048,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M105.892,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M114.814,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M123.736,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M132.658,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M150.502,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M159.423,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M141.58,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M168.345,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M177.267,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M195.111,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M204.033,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M212.955,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M221.877,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M239.721,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M248.643,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M230.799,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M257.565,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M266.487,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M284.331,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M293.253,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M302.175,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M311.097,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M328.941,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M337.863,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M320.019,2.835v8.504"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M346.785,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M355.707,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M373.551,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M382.473,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M391.395,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M400.317,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M418.161,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M427.083,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M409.239,3.189v7.795"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M436.005,4.252v5.669"
            />
            <path
                style="fill: none; stroke: #000000; stroke-width: 0.5"
                d="M444.927,4.252v5.669"
            />
        </g>
        }
    </svg>
</ng-template>

<!-- 0-10000 -->
<ng-template #numberLine_0_10000>
    <svg viewBox="0 0 464 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="0-10000" clip-path="url(#clip0_101:2)">
            <g id="line">
                <path
                    id="Vector"
                    d="M0 7.10001H461.5"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_2"
                    d="M7.80005 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_3"
                    d="M451.3 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
            </g>
            @if (showNumbers) {
            <g id="numbers">
                <g id="Group">
                    <path
                        id="Vector_4"
                        d="M43 23.5H44.3V19.1C44.3 18.9 44.3 18.8 44.3 18.8C44.3 18.8 44.2 18.9 44 19.2L43.4 19.8L43 19.4L44.4 18.1H45V23.5H46.3V24H43V23.5Z"
                        fill="black"
                    />
                    <path
                        id="Vector_5"
                        d="M46.9 21.1C46.9 19.4 47.4 18 49 18C50.6 18 51.1 19.4 51.1 21.1C51.1 22.8 50.6 24.2 49 24.2C47.4 24.2 46.9 22.8 46.9 21.1ZM50.4 21.1C50.4 19.7 50.1 18.6 48.9 18.6C47.8 18.6 47.4 19.7 47.4 21.1C47.4 22.5 47.7 23.6 48.9 23.6C50.1 23.6 50.4 22.5 50.4 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_6"
                        d="M52 21.1C52 19.4 52.5 18 54.1 18C55.7 18 56.2 19.4 56.2 21.1C56.2 22.8 55.7 24.2 54.1 24.2C52.5 24.1 52 22.8 52 21.1ZM55.5 21.1C55.5 19.7 55.2 18.6 54 18.6C52.9 18.6 52.5 19.7 52.5 21.1C52.5 22.5 52.8 23.6 54 23.6C55.2 23.6 55.5 22.5 55.5 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_7"
                        d="M57.1 21.1C57.1 19.4 57.6 18 59.2 18C60.8 18 61.3 19.4 61.3 21.1C61.3 22.8 60.8 24.2 59.2 24.2C57.6 24.2 57.1 22.8 57.1 21.1ZM60.6 21.1C60.6 19.7 60.3 18.6 59.1 18.6C57.9 18.6 57.6 19.7 57.6 21.1C57.6 22.5 57.9 23.6 59.1 23.6C60.3 23.6 60.6 22.5 60.6 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_2">
                    <path
                        id="Vector_8"
                        d="M90 19.6C90 19 89.5 18.5 88.8 18.5C88.2 18.5 87.7 18.8 87.7 19.1V19.4H87.1V19C87.1 18.2 88.1 18 88.7 18C89.8 18 90.5 18.7 90.5 19.7C90.5 21.8 87.3 21.7 87.3 23.4C87.3 23.5 87.4 23.6 87.5 23.6H90C90.1 23.6 90.2 23.5 90.2 23.4V23H90.8V23.6C90.8 24 90.6 24.1 90.3 24.1H87.3C86.9 24.1 86.8 23.9 86.8 23.5C86.8 21.2 90 21.4 90 19.6Z"
                        fill="black"
                    />
                    <path
                        id="Vector_9"
                        d="M91.7001 21.1C91.7001 19.4 92.2001 18 93.8001 18C95.4001 18 95.9001 19.4 95.9001 21.1C95.9001 22.8 95.4001 24.2 93.8001 24.2C92.2001 24.1 91.7001 22.8 91.7001 21.1ZM95.2001 21.1C95.2001 19.7 94.9001 18.6 93.7001 18.6C92.5001 18.6 92.2001 19.7 92.2001 21.1C92.2001 22.5 92.5001 23.6 93.7001 23.6C94.9001 23.6 95.2001 22.5 95.2001 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_10"
                        d="M96.8 21.1C96.8 19.4 97.3 18 98.9 18C100.5 18 101 19.4 101 21.1C101 22.8 100.5 24.2 98.9 24.2C97.4 24.1 96.8 22.8 96.8 21.1ZM100.4 21.1C100.4 19.7 100.1 18.6 98.9 18.6C97.7 18.6 97.4 19.7 97.4 21.1C97.4 22.5 97.7 23.6 98.9 23.6C100.1 23.6 100.4 22.5 100.4 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_11"
                        d="M102 21.1C102 19.4 102.5 18 104.1 18C105.7 18 106.2 19.4 106.2 21.1C106.2 22.8 105.7 24.2 104.1 24.2C102.5 24.2 102 22.8 102 21.1ZM105.5 21.1C105.5 19.7 105.2 18.6 104 18.6C102.8 18.6 102.5 19.7 102.5 21.1C102.5 22.5 102.8 23.6 104 23.6C105.2 23.6 105.5 22.5 105.5 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_3">
                    <path
                        id="Vector_12"
                        d="M131.6 22.9C131.6 22.9 132.2 23.6 133.2 23.6C133.9 23.6 134.6 23.1 134.6 22.3C134.6 21.5 133.9 21 133.1 21H132.7L132.6 20.7L134.1 18.9C134.2 18.7 134.4 18.6 134.4 18.6C134.4 18.6 134.2 18.6 133.9 18.6H132.3C132.2 18.6 132.1 18.7 132.1 18.8V19.2H131.5V18.6C131.5 18.2 131.6 18.1 132 18.1H135V18.5L133.2 20.6C133.9 20.6 135 21.1 135 22.4C135 23.4 134.2 24.3 133 24.3C131.8 24.3 131.1 23.5 131.1 23.5L131.6 22.9Z"
                        fill="black"
                    />
                    <path
                        id="Vector_13"
                        d="M136 21.1C136 19.4 136.5 18 138.1 18C139.7 18 140.2 19.4 140.2 21.1C140.2 22.8 139.7 24.2 138.1 24.2C136.5 24.1 136 22.8 136 21.1ZM139.5 21.1C139.5 19.7 139.2 18.6 138 18.6C136.8 18.6 136.5 19.7 136.5 21.1C136.5 22.5 136.8 23.6 138 23.6C139.2 23.6 139.5 22.5 139.5 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_14"
                        d="M141.1 21.1C141.1 19.4 141.6 18 143.2 18C144.8 18 145.3 19.4 145.3 21.1C145.3 22.8 144.8 24.2 143.2 24.2C141.6 24.1 141.1 22.8 141.1 21.1ZM144.7 21.1C144.7 19.7 144.4 18.6 143.2 18.6C142 18.6 141.7 19.7 141.7 21.1C141.7 22.5 142 23.6 143.2 23.6C144.4 23.6 144.7 22.5 144.7 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_15"
                        d="M146.3 21.1C146.3 19.4 146.8 18 148.4 18C150 18 150.5 19.4 150.5 21.1C150.5 22.8 150 24.2 148.4 24.2C146.8 24.2 146.3 22.8 146.3 21.1ZM149.8 21.1C149.8 19.7 149.5 18.6 148.3 18.6C147.1 18.6 146.8 19.7 146.8 21.1C146.8 22.5 147.1 23.6 148.3 23.6C149.5 23.6 149.8 22.5 149.8 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_4">
                    <path
                        id="Vector_16"
                        d="M175.4 22L178.3 18.1H178.9V21.9H179.9V22.4H178.9V24H178.3V22.4H175.4V22ZM178.4 19.4C178.4 19.1 178.4 18.8 178.4 18.8C178.4 18.8 178.3 19 178.1 19.3L176.4 21.5C176.2 21.7 176.1 21.9 176.1 21.9C176.1 21.9 176.3 21.9 176.6 21.9H178.4V19.4Z"
                        fill="black"
                    />
                    <path
                        id="Vector_17"
                        d="M180.6 21.1C180.6 19.4 181.1 18 182.7 18C184.3 18 184.8 19.4 184.8 21.1C184.8 22.8 184.3 24.2 182.7 24.2C181.1 24.1 180.6 22.8 180.6 21.1ZM184.1 21.1C184.1 19.7 183.8 18.6 182.6 18.6C181.4 18.6 181.1 19.7 181.1 21.1C181.1 22.5 181.4 23.6 182.6 23.6C183.8 23.6 184.1 22.5 184.1 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_18"
                        d="M185.7 21.1C185.7 19.4 186.2 18 187.8 18C189.4 18 189.9 19.4 189.9 21.1C189.9 22.8 189.4 24.2 187.8 24.2C186.2 24.1 185.7 22.8 185.7 21.1ZM189.2 21.1C189.2 19.7 188.9 18.6 187.7 18.6C186.5 18.6 186.2 19.7 186.2 21.1C186.2 22.5 186.5 23.6 187.7 23.6C188.9 23.6 189.2 22.5 189.2 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_19"
                        d="M190.8 21.1C190.8 19.4 191.3 18 192.9 18C194.5 18 195 19.4 195 21.1C195 22.8 194.5 24.2 192.9 24.2C191.3 24.2 190.8 22.8 190.8 21.1ZM194.3 21.1C194.3 19.7 194 18.6 192.8 18.6C191.6 18.6 191.3 19.7 191.3 21.1C191.3 22.5 191.6 23.6 192.8 23.6C194 23.6 194.3 22.5 194.3 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_5">
                    <path
                        id="Vector_20"
                        d="M220.3 22.9C220.3 22.9 220.7 23.6 221.7 23.6C222.6 23.6 223.2 23 223.2 22.2C223.2 21.4 222.5 20.8 221.7 20.8C221 20.8 220.6 21.1 220.6 21.1L220.3 21L220.6 18.6C220.6 18.2 220.8 18.1 221.1 18.1H223.1C223.5 18.1 223.6 18.3 223.6 18.6V19.2H223V18.8C223 18.7 222.9 18.6 222.8 18.6H221.3C221.2 18.6 221.1 18.7 221.1 18.8L220.9 20.2C220.9 20.4 220.8 20.5 220.8 20.5C220.8 20.5 221.2 20.3 221.7 20.3C222.9 20.3 223.8 21.2 223.8 22.2C223.8 23.3 222.9 24.1 221.7 24.1C220.5 24.1 219.9 23.2 219.9 23.2L220.3 22.9Z"
                        fill="black"
                    />
                    <path
                        id="Vector_21"
                        d="M224.8 21.1C224.8 19.4 225.3 18 226.9 18C228.5 18 229 19.4 229 21.1C229 22.8 228.5 24.2 226.9 24.2C225.3 24.1 224.8 22.8 224.8 21.1ZM228.3 21.1C228.3 19.7 228 18.6 226.8 18.6C225.6 18.6 225.3 19.7 225.3 21.1C225.3 22.5 225.6 23.6 226.8 23.6C228 23.6 228.3 22.5 228.3 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_22"
                        d="M229.9 21.1C229.9 19.4 230.4 18 232 18C233.6 18 234.1 19.4 234.1 21.1C234.1 22.8 233.6 24.2 232 24.2C230.4 24.1 229.9 22.8 229.9 21.1ZM233.4 21.1C233.4 19.7 233.1 18.6 231.9 18.6C230.7 18.6 230.4 19.7 230.4 21.1C230.4 22.5 230.7 23.6 231.9 23.6C233.1 23.6 233.4 22.5 233.4 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_23"
                        d="M235 21.1C235 19.4 235.5 18 237.1 18C238.7 18 239.2 19.4 239.2 21.1C239.2 22.8 238.7 24.2 237.1 24.2C235.5 24.2 235 22.8 235 21.1ZM238.5 21.1C238.5 19.7 238.2 18.6 237 18.6C235.8 18.6 235.5 19.7 235.5 21.1C235.5 22.5 235.8 23.6 237 23.6C238.2 23.6 238.5 22.5 238.5 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_6">
                    <path
                        id="Vector_24"
                        d="M264.3 21.4C264.3 19.9 265.1 17.9 266.9 17.9C267.6 17.9 268 18.1 268 18.1L267.8 18.6C267.8 18.6 267.4 18.4 266.9 18.4C265.7 18.4 265 19.6 264.9 20.9C265.2 20.4 265.8 20.2 266.4 20.2C267.5 20.2 268.3 21 268.3 22.1C268.3 23.3 267.5 24.1 266.4 24.1C265.2 24.1 264.3 23 264.3 21.4ZM266.4 23.6C267.2 23.6 267.7 23 267.7 22.2C267.7 21.4 267.2 20.8 266.3 20.8C265.5 20.8 264.9 21.3 264.9 21.8C264.9 22.6 265.6 23.6 266.4 23.6Z"
                        fill="black"
                    />
                    <path
                        id="Vector_25"
                        d="M269.1 21.1C269.1 19.4 269.6 18 271.2 18C272.8 18 273.3 19.4 273.3 21.1C273.3 22.8 272.8 24.2 271.2 24.2C269.6 24.2 269.1 22.8 269.1 21.1ZM272.6 21.1C272.6 19.7 272.3 18.6 271.1 18.6C270 18.6 269.6 19.7 269.6 21.1C269.6 22.5 269.9 23.6 271.1 23.6C272.3 23.6 272.6 22.5 272.6 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_26"
                        d="M274.2 21.1C274.2 19.4 274.7 18 276.3 18C277.9 18 278.4 19.4 278.4 21.1C278.4 22.8 277.9 24.2 276.3 24.2C274.7 24.1 274.2 22.8 274.2 21.1ZM277.8 21.1C277.8 19.7 277.5 18.6 276.3 18.6C275.2 18.6 274.8 19.7 274.8 21.1C274.8 22.5 275.1 23.6 276.3 23.6C277.4 23.6 277.8 22.5 277.8 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_27"
                        d="M279.4 21.1C279.4 19.4 279.9 18 281.5 18C283.1 18 283.6 19.4 283.6 21.1C283.6 22.8 283.1 24.2 281.5 24.2C279.9 24.2 279.4 22.8 279.4 21.1ZM282.9 21.1C282.9 19.7 282.6 18.6 281.4 18.6C280.2 18.6 279.9 19.7 279.9 21.1C279.9 22.5 280.2 23.6 281.4 23.6C282.6 23.6 282.9 22.5 282.9 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_7">
                    <path
                        id="Vector_28"
                        d="M311.9 19.1C312.1 18.8 312.2 18.5 312.2 18.5C312.2 18.5 312 18.5 311.7 18.5H309.6C309.5 18.5 309.4 18.6 309.4 18.7V19.1H308.8V18.5C308.8 18.1 308.9 18 309.3 18H312.8V18.4L309.8 24H309.1L311.9 19.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_29"
                        d="M313.3 21.1C313.3 19.4 313.8 18 315.4 18C317 18 317.5 19.4 317.5 21.1C317.5 22.8 317 24.2 315.4 24.2C313.8 24.2 313.3 22.8 313.3 21.1ZM316.8 21.1C316.8 19.7 316.5 18.6 315.3 18.6C314.2 18.6 313.8 19.7 313.8 21.1C313.8 22.5 314.1 23.6 315.3 23.6C316.5 23.6 316.8 22.5 316.8 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_30"
                        d="M318.4 21.1C318.4 19.4 318.9 18 320.5 18C322.1 18 322.6 19.4 322.6 21.1C322.6 22.8 322.1 24.2 320.5 24.2C318.9 24.1 318.4 22.8 318.4 21.1ZM321.9 21.1C321.9 19.7 321.6 18.6 320.4 18.6C319.3 18.6 318.9 19.7 318.9 21.1C318.9 22.5 319.2 23.6 320.4 23.6C321.6 23.6 321.9 22.5 321.9 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_31"
                        d="M323.5 21.1C323.5 19.4 324 18 325.6 18C327.2 18 327.7 19.4 327.7 21.1C327.7 22.8 327.2 24.2 325.6 24.2C324 24.2 323.5 22.8 323.5 21.1ZM327 21.1C327 19.7 326.7 18.6 325.5 18.6C324.3 18.6 324 19.7 324 21.1C324 22.5 324.3 23.6 325.5 23.6C326.7 23.6 327 22.5 327 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_8">
                    <path
                        id="Vector_32"
                        d="M354.1 20.8C354.1 20.8 353.3 20.4 353.3 19.6C353.3 18.8 353.9 18 355.1 18C356.2 18 356.9 18.7 356.9 19.6C356.9 20.5 356.1 21.1 356.1 21.1C356.7 21.4 357.1 21.8 357.1 22.5C357.1 23.4 356.2 24.2 355.1 24.2C354 24.2 353.1 23.5 353.1 22.4C353 21.3 354.1 20.8 354.1 20.8ZM355 23.6C355.7 23.6 356.4 23.1 356.4 22.4C356.4 21.8 355.9 21.5 355.3 21.3C355.1 21.2 354.7 21.1 354.6 21.1C354.4 21.1 353.6 21.6 353.6 22.4C353.6 23.1 354.3 23.6 355 23.6ZM355.5 20.8C355.7 20.8 356.3 20.2 356.3 19.6C356.3 19 355.8 18.5 355.1 18.5C354.3 18.5 353.9 19 353.9 19.5C353.9 20.1 354.4 20.4 355 20.6C355.1 20.7 355.4 20.8 355.5 20.8Z"
                        fill="black"
                    />
                    <path
                        id="Vector_33"
                        d="M357.9 21.1C357.9 19.4 358.4 18 360 18C361.6 18 362.1 19.4 362.1 21.1C362.1 22.8 361.6 24.2 360 24.2C358.4 24.2 357.9 22.8 357.9 21.1ZM361.4 21.1C361.4 19.7 361.1 18.6 359.9 18.6C358.8 18.6 358.4 19.7 358.4 21.1C358.4 22.5 358.7 23.6 359.9 23.6C361 23.6 361.4 22.5 361.4 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_34"
                        d="M363 21.1C363 19.4 363.5 18 365.1 18C366.7 18 367.2 19.4 367.2 21.1C367.2 22.8 366.7 24.2 365.1 24.2C363.5 24.1 363 22.8 363 21.1ZM366.5 21.1C366.5 19.7 366.2 18.6 365 18.6C363.9 18.6 363.5 19.7 363.5 21.1C363.5 22.5 363.8 23.6 365 23.6C366.2 23.6 366.5 22.5 366.5 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_35"
                        d="M368.1 21.1C368.1 19.4 368.6 18 370.2 18C371.8 18 372.3 19.4 372.3 21.1C372.3 22.8 371.8 24.2 370.2 24.2C368.6 24.2 368.1 22.8 368.1 21.1ZM371.6 21.1C371.6 19.7 371.3 18.6 370.1 18.6C368.9 18.6 368.6 19.7 368.6 21.1C368.6 22.5 368.9 23.6 370.1 23.6C371.3 23.6 371.6 22.5 371.6 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_9">
                    <path
                        id="Vector_36"
                        d="M397.9 23.4C397.9 23.4 398.3 23.6 398.8 23.6C400 23.6 400.7 22.3 400.8 21.1C400.5 21.6 399.9 21.8 399.3 21.8C398.2 21.8 397.4 21 397.4 19.9C397.4 18.7 398.2 17.9 399.3 17.9C400.6 17.9 401.5 19.1 401.5 20.6C401.5 22.1 400.7 24.1 398.9 24.1C398.2 24.1 397.8 23.9 397.8 23.9L397.9 23.4ZM400.7 20.3C400.7 19.5 400.1 18.5 399.2 18.5C398.4 18.5 397.9 19.1 397.9 19.9C397.9 20.7 398.4 21.3 399.3 21.3C400.1 21.3 400.7 20.8 400.7 20.3Z"
                        fill="black"
                    />
                    <path
                        id="Vector_37"
                        d="M402.2 21.1C402.2 19.4 402.7 18 404.3 18C405.9 18 406.4 19.4 406.4 21.1C406.4 22.8 405.9 24.2 404.3 24.2C402.7 24.2 402.2 22.8 402.2 21.1ZM405.7 21.1C405.7 19.7 405.4 18.6 404.2 18.6C403.1 18.6 402.7 19.7 402.7 21.1C402.7 22.5 403 23.6 404.2 23.6C405.4 23.6 405.7 22.5 405.7 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_38"
                        d="M407.3 21.1C407.3 19.4 407.8 18 409.4 18C411 18 411.5 19.4 411.5 21.1C411.5 22.8 411 24.2 409.4 24.2C407.8 24.1 407.3 22.8 407.3 21.1ZM410.8 21.1C410.8 19.7 410.5 18.6 409.3 18.6C408.2 18.6 407.8 19.7 407.8 21.1C407.8 22.5 408.1 23.6 409.3 23.6C410.5 23.6 410.8 22.5 410.8 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_39"
                        d="M412.4 21.1C412.4 19.4 412.9 18 414.5 18C416.1 18 416.6 19.4 416.6 21.1C416.6 22.8 416.1 24.2 414.5 24.2C412.9 24.2 412.4 22.8 412.4 21.1ZM416 21.1C416 19.7 415.7 18.6 414.5 18.6C413.3 18.6 413 19.7 413 21.1C413 22.5 413.3 23.6 414.5 23.6C415.7 23.6 416 22.5 416 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_10">
                    <path
                        id="Vector_40"
                        d="M438.6 23.5H439.9V19.1C439.9 18.9 439.9 18.8 439.9 18.8C439.9 18.8 439.8 18.9 439.6 19.2L439 19.8L438.6 19.4L440 18.1H440.6V23.5H441.9V24H438.7L438.6 23.5Z"
                        fill="black"
                    />
                    <circle
                        id="Ellipse 1"
                        cx="447.667"
                        cy="23.7"
                        r="0.5"
                        fill="black"
                    />
                    <path
                        id="Vector_41"
                        d="M442.5 21.1C442.5 19.4 443 18 444.6 18C446.2 18 446.7 19.4 446.7 21.1C446.7 22.8 446.2 24.2 444.6 24.2C443 24.2 442.5 22.8 442.5 21.1ZM446 21.1C446 19.7 445.7 18.6 444.5 18.6C443.4 18.6 443 19.7 443 21.1C443 22.5 443.3 23.6 444.5 23.6C445.7 23.6 446 22.5 446 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_42"
                        d="M448.6 21.1C448.6 19.4 449.1 18 450.7 18C452.3 18 452.8 19.4 452.8 21.1C452.8 22.8 452.3 24.2 450.7 24.2C449.1 24.1 448.6 22.8 448.6 21.1ZM452.1 21.1C452.1 19.7 451.8 18.6 450.6 18.6C449.5 18.6 449.1 19.7 449.1 21.1C449.1 22.5 449.4 23.6 450.6 23.6C451.8 23.6 452.1 22.5 452.1 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_43"
                        d="M453.8 21.1C453.8 19.4 454.3 18 455.9 18C457.5 18 458 19.4 458 21.1C458 22.8 457.5 24.2 455.9 24.2C454.3 24.2 453.8 22.8 453.8 21.1ZM457.3 21.1C457.3 19.7 457 18.6 455.8 18.6C454.6 18.6 454.3 19.7 454.3 21.1C454.3 22.5 454.6 23.6 455.8 23.6C457 23.6 457.3 22.5 457.3 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_44"
                        d="M458.9 21.1C458.9 19.4 459.4 18 461 18C462.6 18 463.1 19.4 463.1 21.1C463.1 22.8 462.6 24.2 461 24.2C459.4 24.2 458.9 22.8 458.9 21.1ZM462.4 21.1C462.4 19.7 462.1 18.6 460.9 18.6C459.7 18.6 459.4 19.7 459.4 21.1C459.4 22.5 459.7 23.6 460.9 23.6C462.1 23.6 462.4 22.5 462.4 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_11">
                    <path
                        id="Vector_45"
                        d="M5.69995 21.1C5.69995 19.4 6.19995 18 7.79995 18C9.39995 18 9.89995 19.4 9.89995 21.1C9.89995 22.8 9.39995 24.2 7.79995 24.2C6.19995 24.1 5.69995 22.8 5.69995 21.1ZM9.19995 21.1C9.19995 19.7 8.89995 18.6 7.69995 18.6C6.49995 18.6 6.19995 19.7 6.19995 21.1C6.19995 22.5 6.49995 23.6 7.69995 23.6C8.89995 23.6 9.19995 22.5 9.19995 21.1Z"
                        fill="black"
                    />
                </g>
            </g>
            } @if (showUnits) {
            <g id="units">
                <path
                    id="Vector_46"
                    d="M12.2 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_47"
                    d="M16.6 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_48"
                    d="M21.1 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_49"
                    d="M25.5 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_50"
                    d="M34.3999 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_51"
                    d="M38.7999 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_52"
                    d="M29.8999 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_53"
                    d="M43.2 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_54"
                    d="M47.7 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_55"
                    d="M56.5 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_56"
                    d="M61 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_57"
                    d="M65.3999 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_58"
                    d="M69.7999 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_59"
                    d="M78.7 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_60"
                    d="M83.2 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_61"
                    d="M74.2999 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_62"
                    d="M87.6 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_63"
                    d="M92 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_64"
                    d="M100.9 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_65"
                    d="M105.3 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_66"
                    d="M109.8 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_67"
                    d="M114.2 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_68"
                    d="M123.1 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_69"
                    d="M127.5 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_70"
                    d="M118.6 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_71"
                    d="M131.9 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_72"
                    d="M136.4 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_73"
                    d="M145.3 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_74"
                    d="M149.7 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_75"
                    d="M154.1 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_76"
                    d="M158.6 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_77"
                    d="M167.4 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_78"
                    d="M171.9 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_79"
                    d="M163 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_80"
                    d="M176.3 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_81"
                    d="M180.7 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_82"
                    d="M189.6 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_83"
                    d="M194 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_84"
                    d="M198.5 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_85"
                    d="M202.9 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_86"
                    d="M211.8 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_87"
                    d="M216.2 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_88"
                    d="M207.4 1.79999V11"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_89"
                    d="M220.7 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_90"
                    d="M225.1 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_91"
                    d="M234 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_92"
                    d="M238.4 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_93"
                    d="M242.8 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_94"
                    d="M247.3 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_95"
                    d="M256.1 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_96"
                    d="M260.6 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_97"
                    d="M251.7 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_98"
                    d="M265 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_99"
                    d="M269.5 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_100"
                    d="M278.3 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_101"
                    d="M282.8 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_102"
                    d="M287.2 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_103"
                    d="M291.6 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_104"
                    d="M300.5 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_105"
                    d="M304.9 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_106"
                    d="M296.1 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_107"
                    d="M309.4 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_108"
                    d="M313.8 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_109"
                    d="M322.7 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_110"
                    d="M327.1 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_111"
                    d="M331.6 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_112"
                    d="M336 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_113"
                    d="M344.9 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_114"
                    d="M349.3 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_115"
                    d="M340.4 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_116"
                    d="M353.7 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_117"
                    d="M358.2 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_118"
                    d="M367 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_119"
                    d="M371.5 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_120"
                    d="M375.9 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_121"
                    d="M380.3 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_122"
                    d="M389.2 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_123"
                    d="M393.7 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_124"
                    d="M384.8 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_125"
                    d="M398.1 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_126"
                    d="M402.5 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_127"
                    d="M411.4 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_128"
                    d="M415.8 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_129"
                    d="M420.3 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_130"
                    d="M424.7 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_131"
                    d="M433.6 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_132"
                    d="M438 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_133"
                    d="M429.1 1.79999V11"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_134"
                    d="M442.4 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_135"
                    d="M446.9 4.29999V9.99999"
                    stroke="black"
                    stroke-width="0.5"
                />
            </g>
            } @if (showMarkers) {
            <g id="markers">
                <path
                    id="Vector_136"
                    d="M52.1 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_137"
                    d="M96.5 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_138"
                    d="M140.8 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_139"
                    d="M185.2 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_140"
                    d="M229.5 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_141"
                    d="M273.9 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_142"
                    d="M318.2 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_143"
                    d="M362.6 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_144"
                    d="M407 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
            </g>
            }
        </g>
        <defs>
            <clipPath id="clip0_101:2">
                <rect width="463.5" height="26.1" fill="white" />
            </clipPath>
        </defs>
    </svg>
</ng-template>

<!-- 0-100000 -->
<ng-template #numberLine_0_100000>
    <svg viewBox="0 0 464 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="0-100000" clip-path="url(#clip0_101:174)">
            <g id="line">
                <path
                    id="Vector"
                    d="M0 7.10001H461.5"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_2"
                    d="M448.8 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_3"
                    d="M7.80005 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
            </g>
            @if (showNumbers) {
            <g id="numbers">
                <g id="Group">
                    <path
                        id="Vector_4"
                        d="M86.4 19.6C86.4 19 85.9 18.5 85.2 18.5C84.6 18.5 84.1 18.8 84.1 19.1V19.4H83.5V19C83.5 18.2 84.5 18 85.1 18C86.2 18 86.9 18.7 86.9 19.7C86.9 21.8 83.7 21.7 83.7 23.4C83.7 23.5 83.8 23.6 83.9 23.6H86.4C86.5 23.6 86.6 23.5 86.6 23.4V23H87.2V23.6C87.2 24 87 24.1 86.7 24.1H83.7C83.3 24.1 83.2 23.9 83.2 23.5C83.3 21.2 86.4 21.4 86.4 19.6Z"
                        fill="black"
                    />
                    <path
                        id="Vector_5"
                        d="M88.2 21.1C88.2 19.4 88.7 18 90.3 18C91.9 18 92.4 19.4 92.4 21.1C92.4 22.8 91.9 24.2 90.3 24.2C88.7 24.1 88.2 22.8 88.2 21.1ZM91.7 21.1C91.7 19.7 91.4 18.6 90.2 18.6C89 18.6 88.7 19.7 88.7 21.1C88.7 22.5 89 23.6 90.2 23.6C91.4 23.6 91.7 22.5 91.7 21.1Z"
                        fill="black"
                    />
                    <circle
                        id="Ellipse 1"
                        cx="93.4297"
                        cy="23.7"
                        r="0.5"
                        fill="black"
                    />
                    <path
                        id="Vector_6"
                        d="M94.2999 21.1C94.2999 19.4 94.7999 18 96.3999 18C97.9999 18 98.4999 19.4 98.4999 21.1C98.4999 22.8 97.9999 24.2 96.3999 24.2C94.7999 24.1 94.2999 22.8 94.2999 21.1ZM97.7999 21.1C97.7999 19.7 97.4999 18.6 96.2999 18.6C95.0999 18.6 94.7999 19.7 94.7999 21.1C94.7999 22.5 95.0999 23.6 96.2999 23.6C97.4999 23.6 97.7999 22.5 97.7999 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_7"
                        d="M99.3999 21.1C99.3999 19.4 99.8999 18 101.5 18C103.1 18 103.6 19.4 103.6 21.1C103.6 22.8 103.1 24.2 101.5 24.2C99.8999 24.2 99.3999 22.8 99.3999 21.1ZM102.9 21.1C102.9 19.7 102.6 18.6 101.4 18.6C100.2 18.6 99.8999 19.7 99.8999 21.1C99.8999 22.5 100.2 23.6 101.4 23.6C102.6 23.6 102.9 22.5 102.9 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_8"
                        d="M104.5 21.1C104.5 19.4 105 18 106.6 18C108.2 18 108.7 19.4 108.7 21.1C108.7 22.8 108.2 24.2 106.6 24.2C105 24.2 104.5 22.8 104.5 21.1ZM108 21.1C108 19.7 107.7 18.6 106.5 18.6C105.3 18.6 105 19.7 105 21.1C105 22.5 105.3 23.6 106.5 23.6C107.7 23.6 108 22.5 108 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_2">
                    <path
                        id="Vector_9"
                        d="M127.7 22.9C127.7 22.9 128.3 23.6 129.3 23.6C130 23.6 130.7 23.1 130.7 22.3C130.7 21.5 130 21 129.2 21H128.8L128.7 20.7L130.2 18.9C130.3 18.7 130.5 18.6 130.5 18.6C130.5 18.6 130.3 18.6 130 18.6H128.4C128.3 18.6 128.2 18.7 128.2 18.8V19.2H127.6V18.6C127.6 18.2 127.7 18.1 128.1 18.1H131.1V18.5L129.3 20.6C130 20.6 131.1 21.1 131.1 22.4C131.1 23.4 130.3 24.3 129.1 24.3C127.9 24.3 127.2 23.5 127.2 23.5L127.7 22.9Z"
                        fill="black"
                    />
                    <path
                        id="Vector_10"
                        d="M132.1 21.1C132.1 19.4 132.6 18 134.2 18C135.8 18 136.3 19.4 136.3 21.1C136.3 22.8 135.8 24.2 134.2 24.2C132.6 24.1 132.1 22.8 132.1 21.1ZM135.6 21.1C135.6 19.7 135.3 18.6 134.1 18.6C132.9 18.6 132.6 19.7 132.6 21.1C132.6 22.5 132.9 23.6 134.1 23.6C135.3 23.6 135.6 22.5 135.6 21.1Z"
                        fill="black"
                    />
                    <circle
                        id="Ellipse 1_2"
                        cx="137.274"
                        cy="23.7"
                        r="0.5"
                        fill="black"
                    />
                    <path
                        id="Vector_11"
                        d="M138.2 21.1C138.2 19.4 138.7 18 140.3 18C141.9 18 142.4 19.4 142.4 21.1C142.4 22.8 141.9 24.2 140.3 24.2C138.7 24.1 138.2 22.8 138.2 21.1ZM141.7 21.1C141.7 19.7 141.4 18.6 140.2 18.6C139 18.6 138.7 19.7 138.7 21.1C138.7 22.5 139 23.6 140.2 23.6C141.4 23.6 141.7 22.5 141.7 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_12"
                        d="M143.3 21.1C143.3 19.4 143.8 18 145.4 18C147 18 147.5 19.4 147.5 21.1C147.5 22.8 147 24.2 145.4 24.2C143.8 24.2 143.3 22.8 143.3 21.1ZM146.8 21.1C146.8 19.7 146.5 18.6 145.3 18.6C144.1 18.6 143.8 19.7 143.8 21.1C143.8 22.5 144.1 23.6 145.3 23.6C146.5 23.6 146.8 22.5 146.8 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_13"
                        d="M148.5 21.1C148.5 19.4 149 18 150.6 18C152.2 18 152.7 19.4 152.7 21.1C152.7 22.8 152.2 24.2 150.6 24.2C149 24.2 148.5 22.8 148.5 21.1ZM152 21.1C152 19.7 151.7 18.6 150.5 18.6C149.3 18.6 149 19.7 149 21.1C149 22.5 149.3 23.6 150.5 23.6C151.7 23.6 152 22.5 152 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_3">
                    <path
                        id="Vector_14"
                        d="M171.3 22L174.2 18.1H174.8V21.9H175.8V22.4H174.8V24H174.2V22.4H171.3V22ZM174.3 19.4C174.3 19.1 174.3 18.8 174.3 18.8C174.3 18.8 174.2 19 174 19.3L172.3 21.5C172.1 21.7 172 21.9 172 21.9C172 21.9 172.2 21.9 172.5 21.9H174.3V19.4Z"
                        fill="black"
                    />
                    <path
                        id="Vector_15"
                        d="M176.5 21.1C176.5 19.4 177 18 178.6 18C180.2 18 180.7 19.4 180.7 21.1C180.7 22.8 180.2 24.2 178.6 24.2C177 24.1 176.5 22.8 176.5 21.1ZM180 21.1C180 19.7 179.7 18.6 178.5 18.6C177.3 18.6 177 19.7 177 21.1C177 22.5 177.3 23.6 178.5 23.6C179.7 23.6 180 22.5 180 21.1Z"
                        fill="black"
                    />
                    <circle
                        id="Ellipse 1_3"
                        cx="181.698"
                        cy="23.7"
                        r="0.5"
                        fill="black"
                    />
                    <path
                        id="Vector_16"
                        d="M182.6 21.1C182.6 19.4 183.1 18 184.7 18C186.3 18 186.8 19.4 186.8 21.1C186.8 22.8 186.3 24.2 184.7 24.2C183.1 24.1 182.6 22.8 182.6 21.1ZM186.1 21.1C186.1 19.7 185.8 18.6 184.6 18.6C183.4 18.6 183.1 19.7 183.1 21.1C183.1 22.5 183.4 23.6 184.6 23.6C185.8 23.6 186.1 22.5 186.1 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_17"
                        d="M187.7 21.1C187.7 19.4 188.2 18 189.8 18C191.4 18 191.9 19.4 191.9 21.1C191.9 22.8 191.4 24.2 189.8 24.2C188.2 24.2 187.7 22.8 187.7 21.1ZM191.2 21.1C191.2 19.7 190.9 18.6 189.7 18.6C188.5 18.6 188.2 19.7 188.2 21.1C188.2 22.5 188.5 23.6 189.7 23.6C190.9 23.6 191.2 22.5 191.2 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_18"
                        d="M192.8 21.1C192.8 19.4 193.3 18 194.9 18C196.5 18 197 19.4 197 21.1C197 22.8 196.5 24.2 194.9 24.2C193.3 24.2 192.8 22.8 192.8 21.1ZM196.4 21.1C196.4 19.7 196.1 18.6 194.9 18.6C193.7 18.6 193.4 19.7 193.4 21.1C193.4 22.5 193.7 23.6 194.9 23.6C196.1 23.6 196.4 22.5 196.4 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_4">
                    <path
                        id="Vector_19"
                        d="M216 22.9C216 22.9 216.4 23.6 217.4 23.6C218.3 23.6 218.9 23 218.9 22.2C218.9 21.4 218.2 20.8 217.4 20.8C216.7 20.8 216.3 21.1 216.3 21.1L216 21L216.3 18.6C216.3 18.2 216.5 18.1 216.8 18.1H218.8C219.2 18.1 219.3 18.3 219.3 18.6V19.2H218.5V18.8C218.5 18.7 218.4 18.6 218.3 18.6H216.8C216.7 18.6 216.6 18.7 216.6 18.8L216.4 20.2C216.4 20.4 216.3 20.5 216.3 20.5C216.3 20.5 216.7 20.3 217.2 20.3C218.4 20.3 219.3 21.2 219.3 22.2C219.3 23.3 218.4 24.1 217.2 24.1C216 24.1 215.4 23.2 215.4 23.2L216 22.9Z"
                        fill="black"
                    />
                    <path
                        id="Vector_20"
                        d="M220.4 21.1C220.4 19.4 220.9 18 222.5 18C224.1 18 224.6 19.4 224.6 21.1C224.6 22.8 224.1 24.2 222.5 24.2C220.9 24.1 220.4 22.8 220.4 21.1ZM223.9 21.1C223.9 19.7 223.6 18.6 222.4 18.6C221.2 18.6 220.9 19.7 220.9 21.1C220.9 22.5 221.2 23.6 222.4 23.6C223.6 23.6 223.9 22.5 223.9 21.1Z"
                        fill="black"
                    />
                    <circle
                        id="Ellipse 1_4"
                        cx="225.56"
                        cy="23.7"
                        r="0.5"
                        fill="black"
                    />
                    <path
                        id="Vector_21"
                        d="M226.5 21.1C226.5 19.4 227 18 228.6 18C230.2 18 230.7 19.4 230.7 21.1C230.7 22.8 230.2 24.2 228.6 24.2C227 24.1 226.5 22.8 226.5 21.1ZM230.1 21.1C230.1 19.7 229.8 18.6 228.6 18.6C227.4 18.6 227.1 19.7 227.1 21.1C227.1 22.5 227.4 23.6 228.6 23.6C229.8 23.6 230.1 22.5 230.1 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_22"
                        d="M231.7 21.1C231.7 19.4 232.2 18 233.8 18C235.4 18 235.9 19.4 235.9 21.1C235.9 22.8 235.4 24.2 233.8 24.2C232.2 24.2 231.7 22.8 231.7 21.1ZM235.2 21.1C235.2 19.7 234.9 18.6 233.7 18.6C232.5 18.6 232.2 19.7 232.2 21.1C232.2 22.5 232.5 23.6 233.7 23.6C234.9 23.6 235.2 22.5 235.2 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_23"
                        d="M236.8 21.1C236.8 19.4 237.3 18 238.9 18C240.5 18 241 19.4 241 21.1C241 22.8 240.5 24.2 238.9 24.2C237.3 24.2 236.8 22.8 236.8 21.1ZM240.3 21.1C240.3 19.7 240 18.6 238.8 18.6C237.6 18.6 237.3 19.7 237.3 21.1C237.3 22.5 237.6 23.6 238.8 23.6C240 23.6 240.3 22.5 240.3 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_5">
                    <path
                        id="Vector_24"
                        d="M259.7 21.4C259.7 19.9 260.5 17.9 262.3 17.9C263 17.9 263.4 18.1 263.4 18.1L263.2 18.6C263.2 18.6 262.8 18.4 262.3 18.4C261.1 18.4 260.4 19.6 260.3 20.9C260.6 20.4 261.2 20.2 261.8 20.2C262.9 20.2 263.7 21 263.7 22.1C263.7 23.3 262.9 24.1 261.8 24.1C260.6 24.1 259.7 23 259.7 21.4ZM261.9 23.6C262.7 23.6 263.2 23 263.2 22.2C263.2 21.4 262.7 20.8 261.8 20.8C261 20.8 260.4 21.3 260.4 21.8C260.3 22.6 261 23.6 261.9 23.6Z"
                        fill="black"
                    />
                    <path
                        id="Vector_25"
                        d="M264.5 21.1C264.5 19.4 265 18 266.6 18C268.2 18 268.7 19.4 268.7 21.1C268.7 22.8 268.2 24.2 266.6 24.2C265 24.2 264.5 22.8 264.5 21.1ZM268 21.1C268 19.7 267.7 18.6 266.5 18.6C265.4 18.6 265 19.7 265 21.1C265 22.5 265.3 23.6 266.5 23.6C267.7 23.6 268 22.5 268 21.1Z"
                        fill="black"
                    />
                    <circle
                        id="Ellipse 1_5"
                        cx="269.695"
                        cy="23.7"
                        r="0.5"
                        fill="black"
                    />
                    <path
                        id="Vector_26"
                        d="M270.6 21.1C270.6 19.4 271.1 18 272.7 18C274.3 18 274.8 19.4 274.8 21.1C274.8 22.8 274.3 24.2 272.7 24.2C271.1 24.1 270.6 22.8 270.6 21.1ZM274.2 21.1C274.2 19.7 273.9 18.6 272.7 18.6C271.6 18.6 271.2 19.7 271.2 21.1C271.2 22.5 271.5 23.6 272.7 23.6C273.8 23.6 274.2 22.5 274.2 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_27"
                        d="M275.8 21.1C275.8 19.4 276.3 18 277.9 18C279.5 18 280 19.4 280 21.1C280 22.8 279.5 24.2 277.9 24.2C276.3 24.2 275.8 22.8 275.8 21.1ZM279.3 21.1C279.3 19.7 279 18.6 277.8 18.6C276.6 18.6 276.3 19.7 276.3 21.1C276.3 22.5 276.6 23.6 277.8 23.6C279 23.6 279.3 22.5 279.3 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_28"
                        d="M280.9 21.1C280.9 19.4 281.4 18 283 18C284.6 18 285.1 19.4 285.1 21.1C285.1 22.8 284.6 24.2 283 24.2C281.4 24.2 280.9 22.8 280.9 21.1ZM284.4 21.1C284.4 19.7 284.1 18.6 282.9 18.6C281.7 18.6 281.4 19.7 281.4 21.1C281.4 22.5 281.7 23.6 282.9 23.6C284.1 23.6 284.4 22.5 284.4 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_6">
                    <path
                        id="Vector_29"
                        d="M307.1 19.1C307.3 18.8 307.4 18.5 307.4 18.5C307.4 18.5 307.2 18.5 306.9 18.5H304.8C304.7 18.5 304.6 18.6 304.6 18.7V19.1H304V18.5C304 18.1 304.1 18 304.5 18H308V18.4L305 24H304.3L307.1 19.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_30"
                        d="M308.5 21.1C308.5 19.4 309 18 310.6 18C312.2 18 312.7 19.4 312.7 21.1C312.7 22.8 312.2 24.2 310.6 24.2C309 24.2 308.5 22.8 308.5 21.1ZM312 21.1C312 19.7 311.7 18.6 310.5 18.6C309.4 18.6 309 19.7 309 21.1C309 22.5 309.3 23.6 310.5 23.6C311.7 23.6 312 22.5 312 21.1Z"
                        fill="black"
                    />
                    <circle
                        id="Ellipse 1_6"
                        cx="313.733"
                        cy="23.7"
                        r="0.5"
                        fill="black"
                    />
                    <path
                        id="Vector_31"
                        d="M314.6 21.1C314.6 19.4 315.1 18 316.7 18C318.3 18 318.8 19.4 318.8 21.1C318.8 22.8 318.3 24.2 316.7 24.2C315.2 24.1 314.6 22.8 314.6 21.1ZM318.2 21.1C318.2 19.7 317.9 18.6 316.7 18.6C315.6 18.6 315.2 19.7 315.2 21.1C315.2 22.5 315.5 23.6 316.7 23.6C317.8 23.6 318.2 22.5 318.2 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_32"
                        d="M319.8 21.1C319.8 19.4 320.3 18 321.9 18C323.5 18 324 19.4 324 21.1C324 22.8 323.5 24.2 321.9 24.2C320.3 24.2 319.8 22.8 319.8 21.1ZM323.3 21.1C323.3 19.7 323 18.6 321.8 18.6C320.6 18.6 320.3 19.7 320.3 21.1C320.3 22.5 320.6 23.6 321.8 23.6C323 23.6 323.3 22.5 323.3 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_33"
                        d="M324.9 21.1C324.9 19.4 325.4 18 327 18C328.6 18 329.1 19.4 329.1 21.1C329.1 22.8 328.6 24.2 327 24.2C325.4 24.2 324.9 22.8 324.9 21.1ZM328.4 21.1C328.4 19.7 328.1 18.6 326.9 18.6C325.7 18.6 325.4 19.7 325.4 21.1C325.4 22.5 325.7 23.6 326.9 23.6C328.1 23.6 328.4 22.5 328.4 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_7">
                    <path
                        id="Vector_34"
                        d="M349.006 20.8C349.006 20.8 348.206 20.4 348.206 19.6C348.206 18.8 348.806 18 350.006 18C351.106 18 351.806 18.7 351.806 19.6C351.806 20.5 351.006 21.1 351.006 21.1C351.606 21.4 352.006 21.8 352.006 22.5C352.006 23.4 351.106 24.2 350.006 24.2C348.906 24.2 348.006 23.5 348.006 22.4C347.906 21.3 349.006 20.8 349.006 20.8ZM349.906 23.6C350.606 23.6 351.306 23.1 351.306 22.4C351.306 21.8 350.806 21.5 350.206 21.3C350.006 21.2 349.606 21.1 349.506 21.1C349.306 21.1 348.506 21.6 348.506 22.4C348.506 23.1 349.206 23.6 349.906 23.6ZM350.406 20.8C350.606 20.8 351.206 20.2 351.206 19.6C351.206 19 350.706 18.5 350.006 18.5C349.206 18.5 348.806 19 348.806 19.5C348.806 20.1 349.306 20.4 349.906 20.6C350.006 20.7 350.306 20.8 350.406 20.8Z"
                        fill="black"
                    />
                    <path
                        id="Vector_35"
                        d="M352.706 21.1C352.706 19.4 353.206 18 354.806 18C356.406 18 356.906 19.4 356.906 21.1C356.906 22.8 356.406 24.2 354.806 24.2C353.206 24.2 352.706 22.8 352.706 21.1ZM356.306 21.1C356.306 19.7 356.006 18.6 354.806 18.6C353.706 18.6 353.306 19.7 353.306 21.1C353.306 22.5 353.606 23.6 354.806 23.6C355.906 23.6 356.306 22.5 356.306 21.1Z"
                        fill="black"
                    />
                    <circle
                        id="Ellipse 1_7"
                        cx="358.006"
                        cy="23.7"
                        r="0.5"
                        fill="black"
                    />
                    <path
                        id="Vector_36"
                        d="M358.906 21.1C358.906 19.4 359.407 18 361.007 18C362.607 18 363.107 19.4 363.107 21.1C363.107 22.8 362.607 24.2 361.007 24.2C359.407 24.1 358.906 22.8 358.906 21.1ZM362.406 21.1C362.406 19.7 362.106 18.6 360.906 18.6C359.806 18.6 359.406 19.7 359.406 21.1C359.406 22.5 359.706 23.6 360.906 23.6C362.006 23.6 362.406 22.5 362.406 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_37"
                        d="M364.006 21.1C364.006 19.4 364.506 18 366.106 18C367.706 18 368.206 19.4 368.206 21.1C368.206 22.8 367.706 24.2 366.106 24.2C364.506 24.2 364.006 22.8 364.006 21.1ZM367.506 21.1C367.506 19.7 367.206 18.6 366.006 18.6C364.806 18.6 364.506 19.7 364.506 21.1C364.506 22.5 364.806 23.6 366.006 23.6C367.206 23.6 367.506 22.5 367.506 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_38"
                        d="M369.106 21.1C369.106 19.4 369.606 18 371.206 18C372.806 18 373.306 19.4 373.306 21.1C373.306 22.8 372.806 24.2 371.206 24.2C369.606 24.2 369.106 22.8 369.106 21.1ZM372.606 21.1C372.606 19.7 372.306 18.6 371.106 18.6C369.906 18.6 369.606 19.7 369.606 21.1C369.606 22.5 369.906 23.6 371.106 23.6C372.306 23.6 372.606 22.5 372.606 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_8">
                    <path
                        id="Vector_39"
                        d="M392.5 23.4C392.5 23.4 392.9 23.6 393.4 23.6C394.6 23.6 395.3 22.3 395.4 21.1C395.1 21.6 394.5 21.8 393.9 21.8C392.8 21.8 392 21 392 19.9C392 18.7 392.8 17.9 393.9 17.9C395.2 17.9 396.1 19.1 396.1 20.6C396.1 22.1 395.3 24.1 393.5 24.1C392.8 24.1 392.4 23.9 392.4 23.9L392.5 23.4ZM395.4 20.3C395.4 19.5 394.8 18.5 393.9 18.5C393.1 18.5 392.6 19.1 392.6 19.9C392.6 20.7 393.1 21.3 394 21.3C394.7 21.3 395.4 20.8 395.4 20.3Z"
                        fill="black"
                    />
                    <path
                        id="Vector_40"
                        d="M396.8 21.1C396.8 19.4 397.3 18 398.9 18C400.5 18 401 19.4 401 21.1C401 22.8 400.5 24.2 398.9 24.2C397.3 24.2 396.8 22.8 396.8 21.1ZM400.4 21.1C400.4 19.7 400.1 18.6 398.9 18.6C397.8 18.6 397.4 19.7 397.4 21.1C397.4 22.5 397.7 23.6 398.9 23.6C400 23.6 400.4 22.5 400.4 21.1Z"
                        fill="black"
                    />
                    <circle
                        id="Ellipse 1_8"
                        cx="402"
                        cy="23.7"
                        r="0.5"
                        fill="black"
                    />
                    <path
                        id="Vector_41"
                        d="M403 21.1C403 19.4 403.5 18 405.1 18C406.7 18 407.2 19.4 407.2 21.1C407.2 22.8 406.7 24.2 405.1 24.2C403.5 24.1 403 22.8 403 21.1ZM406.5 21.1C406.5 19.7 406.2 18.6 405 18.6C403.9 18.6 403.5 19.7 403.5 21.1C403.5 22.5 403.8 23.6 405 23.6C406.2 23.6 406.5 22.5 406.5 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_42"
                        d="M408.1 21.1C408.1 19.4 408.6 18 410.2 18C411.8 18 412.3 19.4 412.3 21.1C412.3 22.8 411.8 24.2 410.2 24.2C408.6 24.2 408.1 22.8 408.1 21.1ZM411.6 21.1C411.6 19.7 411.3 18.6 410.1 18.6C408.9 18.6 408.6 19.7 408.6 21.1C408.6 22.5 408.9 23.6 410.1 23.6C411.3 23.6 411.6 22.5 411.6 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_43"
                        d="M413.2 21.1C413.2 19.4 413.7 18 415.3 18C416.9 18 417.4 19.4 417.4 21.1C417.4 22.8 416.9 24.2 415.3 24.2C413.7 24.2 413.2 22.8 413.2 21.1ZM416.7 21.1C416.7 19.7 416.4 18.6 415.2 18.6C414 18.6 413.7 19.7 413.7 21.1C413.7 22.5 414 23.6 415.2 23.6C416.4 23.6 416.7 22.5 416.7 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_9">
                    <path
                        id="Vector_44"
                        d="M433.5 23.5H434.8V19.1C434.8 18.9 434.8 18.8 434.8 18.8C434.8 18.8 434.7 18.9 434.5 19.2L433.9 19.8L433.5 19.4L434.9 18.1H435.5V23.5H436.8V24H433.6L433.5 23.5Z"
                        fill="black"
                    />
                    <path
                        id="Vector_45"
                        d="M437.4 21.1C437.4 19.4 437.9 18 439.5 18C441.1 18 441.6 19.4 441.6 21.1C441.6 22.8 441.1 24.2 439.5 24.2C437.9 24.2 437.4 22.8 437.4 21.1ZM440.9 21.1C440.9 19.7 440.6 18.6 439.4 18.6C438.3 18.6 437.9 19.7 437.9 21.1C437.9 22.5 438.2 23.6 439.4 23.6C440.6 23.6 440.9 22.5 440.9 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_46"
                        d="M442.5 21.1C442.5 19.4 443 18 444.6 18C446.2 18 446.7 19.4 446.7 21.1C446.7 22.8 446.2 24.2 444.6 24.2C443 24.1 442.5 22.8 442.5 21.1ZM446 21.1C446 19.7 445.7 18.6 444.5 18.6C443.4 18.6 443 19.7 443 21.1C443 22.5 443.3 23.6 444.5 23.6C445.7 23.6 446 22.5 446 21.1Z"
                        fill="black"
                    />
                    <circle
                        id="Ellipse 1_9"
                        cx="447.664"
                        cy="23.7"
                        r="0.5"
                        fill="black"
                    />
                    <path
                        id="Vector_47"
                        d="M448.6 21.1C448.6 19.4 449.1 18 450.7 18C452.3 18 452.8 19.4 452.8 21.1C452.8 22.8 452.3 24.2 450.7 24.2C449.1 24.2 448.6 22.8 448.6 21.1ZM452.1 21.1C452.1 19.7 451.8 18.6 450.6 18.6C449.4 18.6 449.1 19.7 449.1 21.1C449.1 22.5 449.4 23.6 450.6 23.6C451.8 23.6 452.1 22.5 452.1 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_48"
                        d="M453.8 21.1C453.8 19.4 454.3 18 455.9 18C457.5 18 458 19.4 458 21.1C458 22.8 457.5 24.2 455.9 24.2C454.3 24.2 453.8 22.8 453.8 21.1ZM457.3 21.1C457.3 19.7 457 18.6 455.8 18.6C454.6 18.6 454.3 19.7 454.3 21.1C454.3 22.5 454.6 23.6 455.8 23.6C457 23.6 457.3 22.5 457.3 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_49"
                        d="M458.9 21.1C458.9 19.4 459.4 18 461 18C462.6 18 463.1 19.4 463.1 21.1C463.1 22.8 462.6 24.2 461 24.2C459.4 24.2 458.9 22.8 458.9 21.1ZM462.4 21.1C462.4 19.7 462.1 18.6 460.9 18.6C459.7 18.6 459.4 19.7 459.4 21.1C459.4 22.5 459.7 23.6 460.9 23.6C462.1 23.6 462.4 22.5 462.4 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_10">
                    <path
                        id="Vector_50"
                        d="M39.6 23.5H40.9V19.1C40.9 18.9 40.9 18.8 40.9 18.8C40.9 18.8 40.8 18.9 40.6 19.2L40 19.8L39.6 19.4L41 18.1H41.6V23.5H42.9V24H39.7L39.6 23.5Z"
                        fill="black"
                    />
                    <path
                        id="Vector_51"
                        d="M43.5 21.1C43.5 19.4 44 18 45.6 18C47.2 18 47.7 19.4 47.7 21.1C47.7 22.8 47.2 24.2 45.6 24.2C44 24.2 43.5 22.8 43.5 21.1ZM47 21.1C47 19.7 46.7 18.6 45.5 18.6C44.4 18.6 44 19.7 44 21.1C44 22.5 44.3 23.6 45.5 23.6C46.6 23.6 47 22.5 47 21.1Z"
                        fill="black"
                    />
                    <circle
                        id="Ellipse 1_10"
                        cx="48.6716"
                        cy="23.7"
                        r="0.5"
                        fill="black"
                    />
                    <path
                        id="Vector_52"
                        d="M49.6 21.1C49.6 19.4 50.1 18 51.7 18C53.3 18 53.8 19.4 53.8 21.1C53.8 22.8 53.3 24.2 51.7 24.2C50.1 24.1 49.6 22.8 49.6 21.1ZM53.1 21.1C53.1 19.7 52.8 18.6 51.6 18.6C50.5 18.6 50.1 19.7 50.1 21.1C50.1 22.5 50.4 23.6 51.6 23.6C52.8 23.6 53.1 22.5 53.1 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_53"
                        d="M54.7 21.1C54.7 19.4 55.2 18 56.8 18C58.4 18 58.9 19.4 58.9 21.1C58.9 22.8 58.4 24.2 56.8 24.2C55.2 24.2 54.7 22.8 54.7 21.1ZM58.2 21.1C58.2 19.7 57.9 18.6 56.7 18.6C55.5 18.6 55.2 19.7 55.2 21.1C55.2 22.5 55.5 23.6 56.7 23.6C57.9 23.6 58.2 22.5 58.2 21.1Z"
                        fill="black"
                    />
                    <path
                        id="Vector_54"
                        d="M59.7999 21.1C59.7999 19.4 60.2999 18 61.8999 18C63.4999 18 63.9999 19.4 63.9999 21.1C63.9999 22.8 63.4999 24.2 61.8999 24.2C60.2999 24.2 59.7999 22.8 59.7999 21.1ZM63.2999 21.1C63.2999 19.7 62.9999 18.6 61.7999 18.6C60.5999 18.6 60.3999 19.6 60.3999 21.1C60.3999 22.5 60.6999 23.6 61.8999 23.6C63.0999 23.6 63.2999 22.5 63.2999 21.1Z"
                        fill="black"
                    />
                </g>
                <g id="Group_11">
                    <path
                        id="Vector_55"
                        d="M5.69995 21.1C5.69995 19.4 6.19995 18 7.79995 18C9.39995 18 9.89995 19.4 9.89995 21.1C9.89995 22.8 9.39995 24.2 7.79995 24.2C6.19995 24.1 5.69995 22.8 5.69995 21.1ZM9.19995 21.1C9.19995 19.7 8.89995 18.6 7.69995 18.6C6.49995 18.6 6.19995 19.7 6.19995 21.1C6.19995 22.5 6.49995 23.6 7.69995 23.6C8.89995 23.6 9.19995 22.5 9.19995 21.1Z"
                        fill="black"
                    />
                </g>
            </g>
            } @if (showUnits) {
            <g id="units">
                <path
                    id="Vector_56"
                    d="M12.2 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_57"
                    d="M16.6 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_58"
                    d="M21 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_59"
                    d="M25.3999 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_60"
                    d="M34.2 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_61"
                    d="M38.6 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_62"
                    d="M29.7999 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_63"
                    d="M43 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_64"
                    d="M47.3999 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_65"
                    d="M56.2999 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_66"
                    d="M60.7 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_67"
                    d="M65.1 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_68"
                    d="M69.5 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_69"
                    d="M78.2999 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_70"
                    d="M82.7 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_71"
                    d="M73.8999 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_72"
                    d="M87.1 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_73"
                    d="M91.5 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_74"
                    d="M100.4 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_75"
                    d="M104.8 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_76"
                    d="M109.2 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_77"
                    d="M113.6 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_78"
                    d="M122.4 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_79"
                    d="M126.8 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_80"
                    d="M118 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_81"
                    d="M131.2 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_82"
                    d="M135.6 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_83"
                    d="M144.5 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_84"
                    d="M148.9 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_85"
                    d="M153.3 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_86"
                    d="M157.7 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_87"
                    d="M166.5 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_88"
                    d="M170.9 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_89"
                    d="M162.1 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_90"
                    d="M175.3 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_91"
                    d="M179.7 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_92"
                    d="M188.6 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_93"
                    d="M193 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_94"
                    d="M197.4 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_95"
                    d="M201.8 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_96"
                    d="M210.6 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_97"
                    d="M215 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_98"
                    d="M206.2 1.79999V11"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_99"
                    d="M219.4 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_100"
                    d="M223.8 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_101"
                    d="M232.7 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_102"
                    d="M237.1 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_103"
                    d="M241.5 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_104"
                    d="M245.9 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_105"
                    d="M254.7 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_106"
                    d="M259.1 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_107"
                    d="M250.3 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_108"
                    d="M263.5 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_109"
                    d="M267.9 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_110"
                    d="M276.8 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_111"
                    d="M281.2 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_112"
                    d="M285.6 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_113"
                    d="M290 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_114"
                    d="M298.8 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_115"
                    d="M303.2 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_116"
                    d="M294.4 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_117"
                    d="M307.6 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_118"
                    d="M312 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_119"
                    d="M320.9 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_120"
                    d="M325.3 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_121"
                    d="M329.7 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_122"
                    d="M334.1 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_123"
                    d="M342.9 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_124"
                    d="M347.3 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_125"
                    d="M338.5 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_126"
                    d="M351.7 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_127"
                    d="M356.1 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_128"
                    d="M365 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_129"
                    d="M369.4 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_130"
                    d="M373.8 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_131"
                    d="M378.2 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_132"
                    d="M387 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_133"
                    d="M391.4 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_134"
                    d="M382.6 1.39999V11.3"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_135"
                    d="M395.8 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_136"
                    d="M400.2 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_137"
                    d="M409.1 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_138"
                    d="M413.5 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_139"
                    d="M417.9 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_140"
                    d="M422.3 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_141"
                    d="M431.1 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_142"
                    d="M435.5 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_143"
                    d="M426.7 1.79999V11"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_144"
                    d="M439.9 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_145"
                    d="M444.3 4.19998V9.89998"
                    stroke="black"
                    stroke-width="0.5"
                />
            </g>
            } @if (showMarkers) {
            <g id="markers">
                <path
                    id="Vector_146"
                    d="M51.8999 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_147"
                    d="M96 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_148"
                    d="M140.1 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_149"
                    d="M184.2 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_150"
                    d="M228.3 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_151"
                    d="M272.4 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_152"
                    d="M316.5 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_153"
                    d="M360.6 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
                <path
                    id="Vector_154"
                    d="M404.7 0V14.2"
                    stroke="black"
                    stroke-width="0.5"
                />
            </g>
            }
        </g>
        <defs>
            <clipPath id="clip0_101:174">
                <rect width="463.5" height="26.1" fill="white" />
            </clipPath>
        </defs>
    </svg>
</ng-template>
